<template>
  <div :key="componentKey">
 <div class="p-t-30 boxConcordata">
   <v-flex>
     <v-layout row wrap class p-b-20>
       <v-flex p-t-30>
         <div class="tituloBox p-b-30 border-top">
           <div class="bg-primary barraTitulo"></div>
           <h1 class="text-info font-size-18">
             <strong>{{$t('label.concordataEFalencia')}}</strong>
           </h1>
         </div>
       </v-flex>
     </v-layout>
     <v-layout row wrap class p-b-20>
       <v-flex xs12>
         <v-card>
           <v-layout row wrap>
             <v-flex xs2 sm1 v-show="isAlteracao">
             <v-tooltip  top>
               <v-btn slot="activator" icon @click="editarConcordata()">
                 <v-icon color="grey">edit</v-icon>
               </v-btn>
               <span>Editar</span>
             </v-tooltip>
             </v-flex>

             <v-flex   v-bind:class="{'xs10':isAlteracao,'xs12':!isAlteracao,'sm3':isAlteracao,'sm4':!isAlteracao,'md3':isAlteracao,'md4':!isAlteracao}">
               <v-text-field
                 v-model="modelQualificacao.concordataFalencia.numDocumento"
                 :label="$t('label.numeroDocumento') + testeAstericoEstrangeiro()"
                 :rules="[v=>validaIfObrigatorio(v,validaConcodataFalencia) || $t('messages.validacao.campoObrigatorio')]"
                 :required="validaConcodataFalencia"
                 validate-on-blur
                 :readonly="validaReadonlyConcordata()"
                 maxlength="30"
                 v-mask="maskDocumentoIdentificacaoUpload"
                 @change="removeAprovacaoRejeicaoConcordata(modelQualificacao.concordataFalencia)"
               ></v-text-field>
             </v-flex>

             <v-flex xs6 sm4 md3>
               <datePicker
                 v-model="modelQualificacao.concordataFalencia.dtEmissao"
                 :dataDefault="model.concordataFalencia.dtEmissao"
                 v-mask="maskData"
                 :limitarData="true"
                 :rules="[v=>validaIfObrigatorio(v, validaConcodataFalencia) || $t('messages.validacao.campoObrigatorio'), v=>validaDataInvalida(v, validaConcodataFalencia) || 'Data Inválida']"
                 :label="$t('label.dataEmissao') + testeAstericoEstrangeiro()"
                 :required="validaConcodataFalencia"
                 validate-on-blur
                 :key="dtEmissaoKey"
                 :bloquearData="validaReadonlyConcordata()"
                 @change="removeAprovacaoRejeicaoConcordata(modelQualificacao.concordataFalencia)"
               />
             </v-flex>

             <v-flex xs6 sm4 md3>
               <datePicker
                 v-model="modelQualificacao.concordataFalencia.dtVencimento"
                 :dataDefault="model.concordataFalencia.dtVencimento"
                 v-mask="maskData"
                 :rules="[v=>validaIfObrigatorio(v, validaConcodataFalencia) || $t('messages.validacao.campoObrigatorio'),  v=>validaDataInvalida(v, validaConcodataFalencia) || 'Data Inválida']"
                 :label="$t('label.dataValidade') + testeAstericoEstrangeiro()"
                 :required="validaConcodataFalencia"
                 validate-on-blur
                 :key="dtVencimentoKey"
                 :testarDataVencida="validaDataVencida()"
                 :bloquearData="validaReadonlyConcordata()"
                 @change="removeAprovacaoRejeicaoConcordata(modelQualificacao.concordataFalencia)"
               />
             </v-flex>
             <v-flex xs12 sm6 md4>
               <v-select
                 v-model="modelQualificacao.concordataFalencia.situacaoDoc"
                 :items="enums.situacaoDoc"
                 :label="$t('label.situacao')+testeAstericoEstrangeiro()"
                 item-text="descricao"
                 item-value="valor"
                 :return-object="false"
                 :rules="[v=>validaIfObrigatorio(v, 'situacaoDoc', validaConcodataFalencia ) || $t('messages.validacao.campoObrigatorio')]"
                 validate-on-blur
                 :readonly="validaReadonlyConcordata()"
                 @change="removeAprovacaoRejeicaoConcordata(modelQualificacao.concordataFalencia)"
               ></v-select>
             </v-flex>

             <v-flex xs12 sm6 md5>
               <v-text-field
                 v-model="modelQualificacao.concordataFalencia.codControle"
                 :label="$t('label.codDeControle')"
                 :readonly="validaReadonlyConcordata()"
                 maxlength="50"
                 @change="removeAprovacaoRejeicaoConcordata(modelQualificacao.concordataFalencia)"
               ></v-text-field>
             </v-flex>

             <v-flex
               inputIcon
               xs12
               sm12
               md7
               v-show="!modelQualificacao.concordataFalencia.novoUpload">
               <v-text-field
                 :value="subStrUpload(model.concordataFalencia.arquivoUpload,$t('label.concordataEFalencia'))"
                 :label="$t('label.anexaDocumento')+testeAstericoEstrangeiro()"
                 clearable
                 append-icon="get_app"
                 readonly
                 @click:append="baixarArquivo(model.concordataFalencia.arquivoUpload)"
                 @click:clear="limparAnexo('concordata');editarConcordata()"
               ></v-text-field>
             </v-flex>
             <v-flex xs12 sm12 md7 v-show="modelQualificacao.concordataFalencia.novoUpload">
               <uploadFile
                 tamanhoMaximo="20MB"
                 :required="!(model.tipoCertificado == 2 && (model.tipFornecedor == 'J' || model.tipFornecedor == 'F')) && 
                  modelQualificacao.concordataFalencia.novoUpload
                  && (this.model.flagEstrangeiro==='0')
                  "
                 :label="$t('label.anexaDocumento') +testeAstericoEstrangeiro()"
                 v-model="modelQualificacao.concordataFalencia.file"
                 accept=".pdf, .PDF"/>
             </v-flex>
           </v-layout>
         </v-card>
       </v-flex>
     </v-layout>

     <!--  Bloco título, bullet e select ano balanço 01 -->
    <div row wrap v-if="model.tipFornecedor == 'J'">
      <v-flex p-t-30>
        <div class="border-top"></div>
        <div class="bg-primary barraTitulo"></div>  
        <h1 class="text-info font-size-18 d-flex align-center titH1">        
          <strong class="titBalanco">{{ $t('label.balanco1') }}</strong>
        </h1>      
      </v-flex>

      <v-layout row wrap class="p-b-20 justify-space-between">
        <v-flex xs12 sm4 md4 um>
          <div class="divToolTip">
            <v-tooltip right color="#fff">
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="primary" class="positionBullet" v-on="on" v-bind="attrs" light>info</v-icon>
              </template>

              <v-card class="boxInfoDoc">
                <v-list-tile-content>
                  <v-flex xs12 pb-1>
                    <strong class="text-primary">
                      Prezado Fornecedor,<br /><br />
                      Em atendimento a IN RFB nº 2142/2023 a ECD deve ser transmitida ao Sistema Público de Escrituração Digital (SPED)
                      até o último dia útil do mês de junho do ano subsequente ao ano calendário a que se refere à escrituração.
                    </strong>
                  </v-flex>
                </v-list-tile-content>
              </v-card>
            </v-tooltip>
          </div>
        </v-flex>
        <v-flex xs12 sm4 md4 text-right dois>          
         <v-combobox
           v-model="modelQualificacao.balancoFinanceiro.anoBalanco"            
           :items="anos"
           :label="$t('label.anoBalanco')"
           item-text="ano"
           class="ml-2"
           @change="MudarBalanco1Para2()"
           :rules="[
             v => validaAnoValido(v,1) || 'O ano informado está incompleto ou errado. Favor inserir os quatro dígitos.'
           ]"
         ></v-combobox>           
        </v-flex>
      </v-layout>
    </div>
    <!-- / Bloco título, bullet e select ano balanço 01 -->

     <v-flex p-b-20 v-if="model.tipFornecedor == 'J'">
       <v-card>
         <v-layout row wrap p-b-10>

           <v-flex xs2 sm1 v-show="isAlteracao">
             <v-tooltip top>
               <v-btn slot="activator" icon @click="editarBalanco()">
                 <v-icon color="grey">edit</v-icon>
               </v-btn>
               <span>Editar</span>
             </v-tooltip>
           </v-flex>

           <v-flex xs12   v-bind:class="{'sm5':isAlteracao,'sm6':!isAlteracao,'md3':isAlteracao,'md4':!isAlteracao}">
             <v-text-field
               :label="$t('label.numLivroDiario')+testeAstericoEstrangeiro()"
               v-model="modelQualificacao.balancoFinanceiro.numLivroDiario"
               :rules="[
               v=>validaIfObrigatorio(v, validaBalancoFinanceiro) || $t('messages.validacao.campoObrigatorio')                  
                 ]"
              
               required
               maxlength="10"
               validate-on-blur
               :readonly="validaReadonlyBalanco()"
               @change="removeAprovacaoRejeicaoBalanco(modelQualificacao.balancoFinanceiro)"
             ></v-text-field>
           </v-flex>

           <v-flex xs12 sm6 md3>
             <datePicker
               v-model="modelQualificacao.balancoFinanceiro.dtBalanco"
               :dataDefault="modelQualificacao.balancoFinanceiro.dtBalanco"
               ref="dtBalanco"
               v-mask="maskData"
               :limitarData="true"
               :rules="[
                   v => validaIfObrigatorio(v, validaBalancoFinanceiro) || $t('messages.validacao.campoObrigatorio'),
                   v => validaDataInvalida(v, validaBalancoFinanceiro) || 'Data Inválida',
                   v => validaAnoAnterior(v,1) || 'O ano informado deve ser do ano anterior ao vigente'
                 ]"              
               :label="$t('label.dataDoBalanco') + testeAstericoEstrangeiro()"
               required
               validate-on-blur
               :key="dtBalancoKey"
               :bloquearData="validaReadonlyBalanco()"
               @change="removeAprovacaoRejeicaoBalanco(modelQualificacao.balancoFinanceiro)"
               />
           </v-flex>
           
           <v-flex
             inputIcon
             xs12
             sm12
             md5
             v-show="!modelQualificacao.balancoFinanceiro.novoUpload">
             <v-text-field
               :value="subStrUpload(model.balancoFinanceiro.arquivoUpload,$t('label.balanco1'))"
               :label="$t('label.anexaDocumento')+testeAstericoEstrangeiro()"
               clearable
               append-icon="get_app"
               readonly
               @click:append="baixarArquivo(model.balancoFinanceiro.arquivoUpload)"
               @click:clear="limparAnexo('balanco');editarBalanco()"
             ></v-text-field>
           </v-flex>
           <v-flex xs12 sm12 md5 v-show="modelQualificacao.balancoFinanceiro.novoUpload">
             <uploadFile
               tamanhoMaximo="20MB"
               :required="!(model.tipoCertificado == 2 && model.tipFornecedor == 'J') && (this.model.flagEstrangeiro==='0') &&  modelQualificacao.balancoFinanceiro.novoUpload"
               :label="$t('label.anexaDocumento') +testeAstericoEstrangeiro()"
               v-model="modelQualificacao.balancoFinanceiro.file"
               accept=".pdf, .PDF"/>
           </v-flex>
         </v-layout>
       </v-card>
     </v-flex>

     <v-layout row wrap v-if="model.tipFornecedor == 'J'">
       <v-flex xs12 md6 p-b-10>
         <v-card class="boxShadow">
           <v-card-title primary-title class="p-b-none">
             <v-layout row>
               <v-flex left>
                 <div>
                   <strong class="text-primary">{{$t('label.ativo')}}</strong>
                 </div>
               </v-flex>
               <v-flex right text-xs-right>
                 <v-btn icon @click="ativoShow = !ativoShow">
                   <v-icon>{{ !ativoShow ? 'keyboard_arrow_down' : 'keyboard_arrow_up'}}</v-icon>
                 </v-btn>
               </v-flex>
             </v-layout>
           </v-card-title>

           <v-slide-y-transition>
             <v-layout row wrap v-show="ativoShow" p-b-10>
               <v-flex xs12 sm12 md12>
                 <mascaraMoeda
                   :label="$t('label.ativoCirculante')+testeAstericoEstrangeiro()"
                   :rules="[v=>validaIfObrigatorio(v, validaBalancoFinanceiro) || $t('messages.validacao.campoObrigatorio')]"
                   v-model="modelQualificacao.balancoFinanceiro.ativoCirculante"
                   :valorDefault="modelQualificacao.balancoFinanceiro.ativoCirculante"
                   required
                   :key="valorKey"
                   :bloquearCampo="validaReadonlyBalanco()"/>
               </v-flex>

               <v-flex xs12 sm12 md12 class="p-b-10">
                 <v-toolbar light>
                   <v-toolbar-title>
                     {{$t('label.ativoNaoCirculante')}}:
                     <strong>{{ formatarNumero(ativoNaoCirculante) }}</strong>
                   </v-toolbar-title>
                   <v-spacer></v-spacer>
                 </v-toolbar>
               </v-flex>

               <v-flex xs12 sm6 md6>
                 <mascaraMoeda
                   :label="$t('label.realizavelALongoPrazo')+testeAstericoEstrangeiro()"
                   :rules="[v=>validaIfObrigatorio(v, validaBalancoFinanceiro) || $t('messages.validacao.campoObrigatorio')]"
                   v-model="modelQualificacao.balancoFinanceiro.realizavelLP"
                   :valorDefault="modelQualificacao.balancoFinanceiro.realizavelLP"
                   required
                   validate-on-blur
                   :key="valorKey"
                   :bloquearCampo="validaReadonlyBalanco()">
                 </mascaraMoeda>
               </v-flex>

               <v-flex xs12 sm6 md6>
                 <mascaraMoeda
                   :label="$t('label.investimento')+testeAstericoEstrangeiro()"
                   :rules="[v=>validaIfObrigatorio(v, validaBalancoFinanceiro) || $t('messages.validacao.campoObrigatorio')]"
                   v-model="modelQualificacao.balancoFinanceiro.investimento"
                   :valorDefault="modelQualificacao.balancoFinanceiro.investimento"
                   required
                   validate-on-blur
                   :key="valorKey"
                   :bloquearCampo="validaReadonlyBalanco()">
                 </mascaraMoeda>
               </v-flex>

               <v-flex xs12 sm6 md6>
                 <mascaraMoeda
                   :label="$t('label.imobilizado')+testeAstericoEstrangeiro()"
                   :rules="[v=>validaIfObrigatorio(v, validaBalancoFinanceiro) || $t('messages.validacao.campoObrigatorio')]"
                   v-model="modelQualificacao.balancoFinanceiro.imobilizado"
                   :valorDefault="modelQualificacao.balancoFinanceiro.imobilizado"
                   required
                   validate-on-blur
                   :key="valorKey"
                   :bloquearCampo="validaReadonlyBalanco()">
                 </mascaraMoeda>
               </v-flex>

               <v-flex xs12 sm6 md6>
                 <mascaraMoeda
                   :label="$t('label.intangivel')+testeAstericoEstrangeiro()"
                   :rules="[v=>validaIfObrigatorio(v, validaBalancoFinanceiro) || $t('messages.validacao.campoObrigatorio')]"
                   v-model="modelQualificacao.balancoFinanceiro.intangivel"
                   :valorDefault="modelQualificacao.balancoFinanceiro.intangivel"
                   required
                   validate-on-blur
                   :key="valorKey"
                   :bloquearCampo="validaReadonlyBalanco()"
                 ></mascaraMoeda>
               </v-flex>

               <v-flex xs12 sm12 md12 class="p-b-10">
                 <v-toolbar light>
                   <v-toolbar-title>
                     {{$t('label.ativoTotal')}}:
                     <strong>{{formatarNumero(ativoTotal)}}</strong>
                   </v-toolbar-title>
                   <v-spacer></v-spacer>
                 </v-toolbar>
               </v-flex>
             </v-layout>
           </v-slide-y-transition>
         </v-card>
         <div class="p-b-10"></div>
       </v-flex>

       <v-flex xs12 md6 p-b-10>
         <v-card class="boxShadow">
           <v-card-title primary-title class="p-b-none">
             <v-layout row>
               <v-flex left>
                 <div>
                   <strong class="text-primary">{{$t('label.passivo')}}</strong>
                 </div>
               </v-flex>
               <v-flex right text-xs-right>
                 <v-btn icon @click="passivoShow = !passivoShow">
                   <v-icon>{{ !passivoShow ? 'keyboard_arrow_down' : 'keyboard_arrow_up'}}</v-icon>
                 </v-btn>
               </v-flex>
             </v-layout>
           </v-card-title>

           <v-slide-y-transition>
             <v-layout row wrap v-show="passivoShow" p-b-10>
               <v-flex xs12 sm12 md12>
                 <mascaraMoeda
                   :label="$t('label.passivoCirculante')+testeAstericoEstrangeiro()"
                   :rules="[v=>validaIfObrigatorio(v, validaBalancoFinanceiro) || $t('messages.validacao.campoObrigatorio')]"
                   v-model="modelQualificacao.balancoFinanceiro.passivoCirculante"
                   :valorDefault="modelQualificacao.balancoFinanceiro.passivoCirculante"
                   required
                   validate-on-blur
                   :key="valorKey"
                   :bloquearCampo="validaReadonlyBalanco()">
                 </mascaraMoeda>
               </v-flex>

               <v-flex xs12 sm12 md12 class="p-b-10">
                 <v-toolbar light>
                   <v-toolbar-title>
                     {{$t('label.passivoNaoCirculante')}}:
                     <strong>{{formatarNumero(passivoNaoCirculante)}}</strong>
                   </v-toolbar-title>
                   <v-spacer></v-spacer>
                 </v-toolbar>
               </v-flex>

               <v-flex xs12 sm5 md5>
                 <mascaraMoeda
                   :label="$t('label.exigivelALongoPrazo')+testeAstericoEstrangeiro()"
                   :rules="[v=>validaIfObrigatorio(v, validaBalancoFinanceiro) || $t('messages.validacao.campoObrigatorio')]"
                   v-model="modelQualificacao.balancoFinanceiro.exigivelLP"
                   :valorDefault="modelQualificacao.balancoFinanceiro.exigivelLP"
                   required
                   validate-on-blur
                   :key="valorKey"
                   :bloquearCampo="validaReadonlyBalanco()">
                 </mascaraMoeda>
               </v-flex>

               <v-flex xs12 sm7 md7>
                 <mascaraMoeda
                   :label="$t('label.resultadoDeExerciciosFuturos')+testeAstericoEstrangeiro()"
                   :rules="[v=>validaIfObrigatorio(v, validaBalancoFinanceiro) || $t('messages.validacao.campoObrigatorio')]"
                   v-model="modelQualificacao.balancoFinanceiro.resultExerciciosFut"
                   :valorDefault="modelQualificacao.balancoFinanceiro.resultExerciciosFut"
                   required
                   validate-on-blur
                   :key="valorKey"
                   :bloquearCampo="validaReadonlyBalanco()">
                 </mascaraMoeda>
               </v-flex>

               <v-flex xs12 sm12 md12>
                 <mascaraMoeda
                   :label="$t('label.patrimonioLiquido')+testeAstericoEstrangeiro()"
                   :rules="[v=>validaIfObrigatorio(v, validaBalancoFinanceiro) || $t('messages.validacao.campoObrigatorio')]"
                   v-model="modelQualificacao.balancoFinanceiro.patrimonioLiquido"
                   :valorDefault="modelQualificacao.balancoFinanceiro.patrimonioLiquido"
                   required
                   validate-on-blur
                   :key="valorKey"
                   :bloquearCampo="validaReadonlyBalanco()">
                 </mascaraMoeda>
               </v-flex>

               <v-flex xs12 sm12 md12 class="p-b-10">
                 <v-toolbar light>
                   <v-toolbar-title>
                     {{$t('label.passivoTotal')}}:
                     <strong>{{formatarNumero(passivoTotal)}}</strong>
                   </v-toolbar-title>
                   <v-spacer></v-spacer>
                 </v-toolbar>
               </v-flex>
             </v-layout>
           </v-slide-y-transition>
         </v-card>
         <div class="p-b-10"></div>
       </v-flex>
       <v-flex xs12 md12 p-b-10>
         <v-card class="boxShadow">
           <v-card-title primary-title class="p-b-none">
             <v-layout row>
               <v-flex left>
                 <div>
                   <strong class="text-primary">{{$t('label.receita')}}</strong>
                 </div>
               </v-flex>
               <v-flex right text-xs-right>
                 <v-btn icon @click="receitaShow = !receitaShow">
                   <v-icon>{{ !receitaShow ? 'keyboard_arrow_down' : 'keyboard_arrow_up'}}</v-icon>
                 </v-btn>
               </v-flex>
             </v-layout>
           </v-card-title>

           <v-slide-y-transition>
             <v-layout row wrap v-show="receitaShow" p-b-10>
               <v-flex xs12 sm4 md4>
                 <mascaraMoeda
                   :label="$t('label.capitalSocial')+testeAstericoEstrangeiro()"
                   :rules="[v=>validaIfObrigatorio(v, validaBalancoFinanceiro) || $t('messages.validacao.campoObrigatorio')]"
                   v-model="modelQualificacao.balancoFinanceiro.capitalSocial"
                   :valorDefault="modelQualificacao.balancoFinanceiro.capitalSocial"
                   required
                   validate-on-blur
                   :key="valorKey"
                   :bloquearCampo="validaReadonlyBalanco()">
                 </mascaraMoeda>
               </v-flex>

               <v-flex xs12 sm4 md4>
                 <mascaraMoeda
                   :label="$t('label.receitaOperacionalLiquida')+testeAstericoEstrangeiro()"
                   :rules="[v=>validaIfObrigatorio(v, validaBalancoFinanceiro) || $t('messages.validacao.campoObrigatorio')]"
                   v-model="modelQualificacao.balancoFinanceiro.receitaOpeLiquido"
                   :valorDefault="modelQualificacao.balancoFinanceiro.receitaOpeLiquido"
                   required
                   validate-on-blur
                   :key="valorKey"
                   :bloquearCampo="validaReadonlyBalanco()">
                 </mascaraMoeda>
               </v-flex>

               <v-flex xs12 sm4 md4>
                 <mascaraMoeda
                   :label="$t('label.receitaOperacionalBruta')+testeAstericoEstrangeiro()"
                   :rules="[v=>validaIfObrigatorio(v, validaBalancoFinanceiro) || $t('messages.validacao.campoObrigatorio')]"
                   v-model="modelQualificacao.balancoFinanceiro.receitaOpeBruto"
                   :valorDefault="modelQualificacao.balancoFinanceiro.receitaOpeBruto"
                   required
                   validate-on-blur
                   :key="valorKey"
                   :bloquearCampo="validaReadonlyBalanco()">
                 </mascaraMoeda>
               </v-flex>
             </v-layout>
           </v-slide-y-transition>
         </v-card>
         <div class="p-b-10"></div>
       </v-flex>

       <v-flex xs12 md12 p-l-none p-r-none>
         <v-layout row wrap>
           <v-flex xs4 sm4 md4 class="p-b-10">
             <v-toolbar light>
               <v-toolbar-title>
                 {{$t('label.mediaFinanceira')}}:
                 <strong>{{formatarNumero(mediaFinanceira)}}</strong>
               </v-toolbar-title>
               <v-spacer></v-spacer>
             </v-toolbar>
           </v-flex>
           <v-flex xs4 sm4 md4 class="p-b-10">
             <v-toolbar light>
               <v-toolbar-title>
                 {{$t('label.liquidezCorrente')}}:
                 <strong>{{formatarNumero(liquidezCorrente)}}</strong>
               </v-toolbar-title>
               <v-spacer></v-spacer>
             </v-toolbar>
           </v-flex>
           <v-flex xs4 sm4 md4 class="p-b-10">
             <v-toolbar light>
               <v-toolbar-title>
                 {{$t('label.liquidezGeral')}}:
                 <strong>{{formatarNumero(liquidezGeral)}}</strong>
               </v-toolbar-title>
               <v-spacer></v-spacer>
             </v-toolbar>
           </v-flex>
           <v-flex xs4 sm4 md4 class="p-b-10">
             <v-toolbar light>
               <v-toolbar-title>
                 {{$t('label.solvenciaGeral')}}:
                 <strong>{{formatarNumero(solvenciaGeral)}}</strong>
               </v-toolbar-title>
               <v-spacer></v-spacer>
             </v-toolbar>
           </v-flex>
           <v-flex xs4 sm4 md4 class="p-b-10">
             <v-toolbar light>
               <v-toolbar-title>
                 {{$t('label.produtividade')}}:
                 <strong>{{formatarNumero(produtividade)}}</strong>
               </v-toolbar-title>
               <v-spacer></v-spacer>
             </v-toolbar>
           </v-flex>
           <v-flex xs4 sm4 md4 class="p-b-10">
             <v-toolbar light>
               <v-toolbar-title>
                 {{$t('label.endividamento')}}:
                 <strong>{{formatarNumero(endividamento)}}</strong>
               </v-toolbar-title>
               <v-spacer></v-spacer>
             </v-toolbar>
           </v-flex>
           <v-flex xs4 sm4 md4 class="p-b-10">
             <v-toolbar light>
               <v-toolbar-title>
                 {{$t('label.imobilizacaoCapitalProprio')}}:
                 <strong>{{formatarNumero(imobilizacaoCapitalProprio,true)}}</strong>
               </v-toolbar-title>
               <v-spacer></v-spacer>
             </v-toolbar>
           </v-flex>
           <v-flex xs4 sm4 md4 class="p-b-10">
             <v-toolbar light>
               <v-toolbar-title>
                 {{$t('label.capitalizacao')}}:
                 <strong>{{formatarNumero(capitalizacao,true)}}</strong>
               </v-toolbar-title>
               <v-spacer></v-spacer>
             </v-toolbar>
           </v-flex>
         </v-layout>
       </v-flex>
     </v-layout>

     
    <!--  Bloco título, bullet e select ano balanço 02 -->
    <div row wrap v-if="model.tipFornecedor == 'J' && this.model.tipoCertificado === 1 &&  obrigarBalanco2() != 'semBalanco2'"  >      
      <v-flex p-t-30>
        <div class="border-top"></div>
        <div class="bg-primary barraTitulo"></div>  
        <h1 class="text-info font-size-18 d-flex align-center titH1">        
          <strong class="titBalanco">{{ $t('label.balanco2') }}</strong>
        </h1>      
      </v-flex>

      <v-layout row wrap class="p-b-20 justify-space-between">
        <v-flex xs12 sm4 md4 um>
          <div class="divToolTip">
            <v-tooltip right color="#fff">
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="primary" class="positionBullet" v-on="on" v-bind="attrs" light>info</v-icon>
              </template>

              <v-card class="boxInfoDoc">
                <v-list-tile-content>
                  <v-flex xs12 pb-1>
                    <strong class="text-primary">Prezado Fornecedor,<br /><br />
                        Considerando que no Balanço 01 serão registrados os dados conforme IN RFB nº 2142/2023, as informações que deverão 
                        ser preenchidas no Balanço 02 referem-se ao ano anterior ao ano registrado no Balanço 01.
                    </strong>
                  </v-flex>
                </v-list-tile-content>
              </v-card>
            </v-tooltip>
          </div>
        </v-flex>
        <v-flex xs12 sm4 md4 text-right dois>
        
          <v-combobox
            v-model="modelQualificacao.balancoFinanceiro.anoBalanco2"            
            :items="anos2"
            :label="$t('label.anoBalanco2')"
            item-text="ano"
            :readonly=this.migrarBalancos
            class="ml-2"
            ref="anoBalanco2"
            :rules="[
              v => validaAnoValido(v,2) || 'O ano informado está incompleto ou errado. Favor inserir os quatro dígitos.'
            ]"
          ></v-combobox>
        </v-flex>
      </v-layout>
    </div>
    <!-- / Bloco título, bullet e select ano balanço 02 -->

     <v-flex p-b-20 v-if="model.tipFornecedor == 'J'  && this.model.tipoCertificado === 1 &&  obrigarBalanco2() != 'semBalanco2'">
       <v-card>
         <v-layout row wrap p-b-10>
            <div v-show="!migrarBalancos"><!-- migração balanços -->
              <v-flex xs2 sm1 v-show="isAlteracao">
                <v-tooltip top>
                  <v-btn slot="activator" icon @click="editarBalanco2()">
                    <v-icon color="grey">edit</v-icon>
                  </v-btn>
                  <span>Editar</span>
                </v-tooltip>
              </v-flex>
            </div><!-- / migração balanços -->
          
            <v-flex xs12 v-bind:class="{'sm5': isAlteracao, 'sm6': !isAlteracao, 'md3': isAlteracao, 'md4': !isAlteracao}">                
              <v-text-field
                  :label="$t('label.numLivroDiario') + testeAstericoEstrangeiro()"
                  v-model="modelQualificacao.balancoFinanceiro.numLivroDiario02"
                  :rules="[
                      () => this.obrigarBalanco2() !== 'obrigabalanco2' || !!modelQualificacao.balancoFinanceiro.numLivroDiario02 || $t('messages.validacao.campoObrigatorio')
                  ]"
                  :required="this.obrigarBalanco2() === 'obrigabalanco2'"
                  maxlength="10"
                  validate-on-blur
                  :readonly="validaReadonlyBalanco02()"
                  @change="removeAprovacaoRejeicaoBalanco02(modelQualificacao.balancoFinanceiro)"
              ></v-text-field>
            </v-flex>
           
           <v-flex xs12 sm6 md3>            
             <datePicker
               v-model="modelQualificacao.balancoFinanceiro.dtBalanco02"
               :dataDefault="model.balancoFinanceiro.dtBalanco02"
                 ref="dtBalanco02"
               v-mask="maskData"
               :limitarData="true"
               :rules="[
                   v=>validaIfObrigatorioBalanc2(v, validaBalancoFinanceiro02) || $t('messages.validacao.campoObrigatorio'),
                   v => validaDataInvalida(v, validaBalancoFinanceiro02) || 'Data Inválida',
                   v => validaAnoAnterior(v,2) || 'O ano informado deve ser 2 anos anteriores ao vigente'
                   
                 ]"                
               :label="$t('label.dataDoBalanco') + testeAstericoEstrangeiro()"
               required
               validate-on-blur
               :key="dtBalancoKey02"
               :bloquearData="validaReadonlyBalanco02()"
               @change="removeAprovacaoRejeicaoBalanco02(modelQualificacao.balancoFinanceiro)"
               />              
           </v-flex>
           <!-- <v-flex xs12 sm6 md6>
             <datePicker
               v-model="modelQualificacao.balancoFinanceiro.dtValidadeBalanco02"
               :dataDefault="model.balancoFinanceiro.dtValidadeBalanco02"
               v-mask="maskData"
               :limitarData="false"
               :rules="[v=>validaIfObrigatorioBalanc2(v,validaBalancoFinanceiro02) || $t('messages.validacao.campoObrigatorio'), v=>validaDataInvalida(v, validaBalancoFinanceiro02) || 'Data Inválida']"
               :label="$t('label.dataValidadeDoBalanco') + testeAstericoEstrangeiro()"
               required
               validate-on-blur
               @change="removeAprovacaoRejeicaoBalanco02(modelQualificacao.balancoFinanceiro)"
               />
           </v-flex> -->

            <v-flex
              inputIcon
              xs12
              sm12
              md5
              v-show="!modelQualificacao.balancoFinanceiro.novoUpload02">
              <v-text-field
                v-if="migrarBalancos"
                :value="subStrUpload(model.balancoFinanceiro.arquivoUpload02,$t('label.balanco2'))"
                :label="$t('label.anexaDocumento')+testeAstericoEstrangeiro()"                
                append-icon="get_app"               
                readonly
                @click:append="baixarArquivo(model.balancoFinanceiro.arquivoUpload02)"               
              ></v-text-field>
              <v-text-field
                v-else
                :value="subStrUpload(model.balancoFinanceiro.arquivoUpload02,$t('label.balanco2'))"
                :label="$t('label.anexaDocumento')+testeAstericoEstrangeiro()"
                clearable
                append-icon="get_app"               
                readonly                
                @click:append="baixarArquivo(model.balancoFinanceiro.arquivoUpload02)"
                @click:clear="limparAnexo('balanco2');editarBalanco2()"
              ></v-text-field>
            </v-flex>        
             
           <v-flex :key="componentKeyUp" xs12 sm12 md5 v-show="modelQualificacao.balancoFinanceiro.novoUpload02">              
               <uploadFile
               tamanhoMaximo="20MB"   
               :required="this.obrigarBalanco2() === 'obrigabalanco2' && modelQualificacao.balancoFinanceiro.arquivoUpload02 == null"
               :label="$t('label.anexaDocumento') +testeAstericoEstrangeiro()"
               v-model="modelQualificacao.balancoFinanceiro.file02"
               accept=".pdf, .PDF"/>
           </v-flex>
         </v-layout>
       </v-card>
     </v-flex>

     <v-layout row wrap v-if="model.tipFornecedor == 'J'  && this.model.tipoCertificado === 1 &&  obrigarBalanco2() != 'semBalanco2'">
       <v-flex xs12 md6 p-b-10>
         <v-card class="boxShadow">
           <v-card-title primary-title class="p-b-none">
             <v-layout row>
               <v-flex left>
                 <div>
                   <strong class="text-primary">{{$t('label.ativo')}}</strong>
                 </div>
               </v-flex>
               <v-flex right text-xs-right>
                 <v-btn icon @click="ativoShow = !ativoShow">
                   <v-icon>{{ !ativoShow ? 'keyboard_arrow_down' : 'keyboard_arrow_up'}}</v-icon>
                 </v-btn>
               </v-flex>
             </v-layout>
           </v-card-title>

           <v-slide-y-transition>
             <v-layout row wrap v-show="ativoShow" p-b-10>
               <v-flex xs12 sm12 md12>
                 <mascaraMoeda
                   :label="$t('label.ativoCirculante')+testeAstericoEstrangeiro()"
                   :rules="[v=>validaIfObrigatorioBalanc2(v, validaBalancoFinanceiro02) || $t('messages.validacao.campoObrigatorio')]"
                   v-model="modelQualificacao.balancoFinanceiro.ativoCirculante02"
                   :valorDefault="modelQualificacao.balancoFinanceiro.ativoCirculante02"
                   required
                   :key="valorKey02"
                   :bloquearCampo="validaReadonlyBalanco02()"/>              
               </v-flex>

               <v-flex xs12 sm12 md12 class="p-b-10">
                 <v-toolbar light>
                   <v-toolbar-title>
                     {{$t('label.ativoNaoCirculante')}}:
                     <strong>{{ formatarNumero(ativoNaoCirculante02) }}</strong>
                   </v-toolbar-title>
                   <v-spacer></v-spacer>
                 </v-toolbar>
               </v-flex>

               <v-flex xs12 sm6 md6>
                  <mascaraMoeda
                    :label="$t('label.realizavelALongoPrazo')+testeAstericoEstrangeiro()"
                    :rules="[v=>validaIfObrigatorioBalanc2(v, validaBalancoFinanceiro02) || $t('messages.validacao.campoObrigatorio')]"
                    v-model="modelQualificacao.balancoFinanceiro.realizavelLP02"
                    :valorDefault="modelQualificacao.balancoFinanceiro.realizavelLP02"
                    required
                    validate-on-blur
                    :key="valorKey02"
                    :bloquearCampo="validaReadonlyBalanco02()">
                  </mascaraMoeda>
               </v-flex>

               <v-flex xs12 sm6 md6>
                 <mascaraMoeda
                   :label="$t('label.investimento')+testeAstericoEstrangeiro()"
                   :rules="[v=>validaIfObrigatorioBalanc2(v, validaBalancoFinanceiro02) || $t('messages.validacao.campoObrigatorio')]"
                   v-model="modelQualificacao.balancoFinanceiro.investimento02"
                   :valorDefault="modelQualificacao.balancoFinanceiro.investimento02"
                   required
                   validate-on-blur
                   :key="valorKey02"
                   :bloquearCampo="validaReadonlyBalanco02()">
                 </mascaraMoeda>
               </v-flex>

               <v-flex xs12 sm6 md6>
                 <mascaraMoeda
                   :label="$t('label.imobilizado')+testeAstericoEstrangeiro()"
                   :rules="[v=>validaIfObrigatorioBalanc2(v, validaBalancoFinanceiro02) || $t('messages.validacao.campoObrigatorio')]"
                   v-model="modelQualificacao.balancoFinanceiro.imobilizado02"
                   :valorDefault="modelQualificacao.balancoFinanceiro.imobilizado02"
                   required
                   validate-on-blur
                   :key="valorKey"
                   :bloquearCampo="validaReadonlyBalanco02()">
                 </mascaraMoeda>
               </v-flex>

               <v-flex xs12 sm6 md6>
                 <mascaraMoeda
                   :label="$t('label.intangivel')+testeAstericoEstrangeiro()"
                   :rules="[v=>validaIfObrigatorioBalanc2(v, validaBalancoFinanceiro02) || $t('messages.validacao.campoObrigatorio')]"
                   v-model="modelQualificacao.balancoFinanceiro.intangivel02"
                   :valorDefault="modelQualificacao.balancoFinanceiro.intangivel02"
                   required
                   validate-on-blur
                   :key="valorKey02"
                   :bloquearCampo="validaReadonlyBalanco02()"
                 ></mascaraMoeda>
               </v-flex>

               <v-flex xs12 sm12 md12 class="p-b-10">
                 <v-toolbar light>
                   <v-toolbar-title>
                     {{$t('label.ativoTotal')}}:
                     <strong>{{formatarNumero(ativoTotal02)}}</strong>
                   </v-toolbar-title>
                   <v-spacer></v-spacer>
                 </v-toolbar>
               </v-flex>
             </v-layout>
           </v-slide-y-transition>
         </v-card>
         <div class="p-b-10"></div>
       </v-flex>

       <v-flex xs12 md6 p-b-10>
         <v-card class="boxShadow">
           <v-card-title primary-title class="p-b-none">
             <v-layout row>
               <v-flex left>
                 <div>
                   <strong class="text-primary">{{$t('label.passivo')}}</strong>
                 </div>
               </v-flex>
               <v-flex right text-xs-right>
                 <v-btn icon @click="passivoShow = !passivoShow">
                   <v-icon>{{ !passivoShow ? 'keyboard_arrow_down' : 'keyboard_arrow_up'}}</v-icon>
                 </v-btn>
               </v-flex>
             </v-layout>
           </v-card-title>

           <v-slide-y-transition>
             <v-layout row wrap v-show="passivoShow" p-b-10>
               <v-flex xs12 sm12 md12>
                 <mascaraMoeda
                   :label="$t('label.passivoCirculante')+testeAstericoEstrangeiro()"
                   :rules="[v=>validaIfObrigatorioBalanc2(v, validaBalancoFinanceiro02) || $t('messages.validacao.campoObrigatorio')]"
                   v-model="modelQualificacao.balancoFinanceiro.passivoCirculante02"
                   :valorDefault="modelQualificacao.balancoFinanceiro.passivoCirculante02"
                   required
                   validate-on-blur
                   :key="valorKey02"
                   :bloquearCampo="validaReadonlyBalanco02()">
                 </mascaraMoeda>
                </v-flex>

               <v-flex xs12 sm12 md12 class="p-b-10">
                 <v-toolbar light>
                   <v-toolbar-title>
                     {{$t('label.passivoNaoCirculante')}}:
                     <strong>{{formatarNumero(passivoNaoCirculante02)}}</strong>
                   </v-toolbar-title>
                   <v-spacer></v-spacer>
                 </v-toolbar>
               </v-flex>

               <v-flex xs12 sm5 md5>
                  <mascaraMoeda
                    :label="$t('label.exigivelALongoPrazo')+testeAstericoEstrangeiro()"
                    :rules="[v=>validaIfObrigatorioBalanc2(v, validaBalancoFinanceiro02) || $t('messages.validacao.campoObrigatorio')]"
                    v-model="modelQualificacao.balancoFinanceiro.exigivelLP02"
                    :valorDefault="modelQualificacao.balancoFinanceiro.exigivelLP02"
                    required
                    validate-on-blur
                    :key="valorKey02"
                    :bloquearCampo="validaReadonlyBalanco02()">
                  </mascaraMoeda>
               </v-flex>

               <v-flex xs12 sm7 md7>
                 <mascaraMoeda
                   :label="$t('label.resultadoDeExerciciosFuturos')+testeAstericoEstrangeiro()"
                   :rules="[v=>validaIfObrigatorioBalanc2(v, validaBalancoFinanceiro02) || $t('messages.validacao.campoObrigatorio')]"
                   v-model="modelQualificacao.balancoFinanceiro.resultExerciciosFut02"
                   :valorDefault="modelQualificacao.balancoFinanceiro.resultExerciciosFut02"
                   required
                   validate-on-blur
                   :key="valorKey02"
                   :bloquearCampo="validaReadonlyBalanco02()">
                 </mascaraMoeda>
               </v-flex>

               <v-flex xs12 sm12 md12>
                  <mascaraMoeda
                    :label="$t('label.patrimonioLiquido')+testeAstericoEstrangeiro()"
                    :rules="[v=>validaIfObrigatorioBalanc2(v, validaBalancoFinanceiro02) || $t('messages.validacao.campoObrigatorio')]"
                    v-model="modelQualificacao.balancoFinanceiro.patrimonioLiquido02"
                    :valorDefault="modelQualificacao.balancoFinanceiro.patrimonioLiquido02"
                    required
                    validate-on-blur
                    :key="valorKey02"
                    :bloquearCampo="validaReadonlyBalanco02()">
                  </mascaraMoeda>
               </v-flex>

               <v-flex xs12 sm12 md12 class="p-b-10">
                 <v-toolbar light>
                   <v-toolbar-title>
                     {{$t('label.passivoTotal')}}:
                     <strong>{{formatarNumero(passivoTotal02)}}</strong>
                   </v-toolbar-title>
                   <v-spacer></v-spacer>
                 </v-toolbar>
               </v-flex>
             </v-layout>
           </v-slide-y-transition>
         </v-card>
         <div class="p-b-10"></div>
       </v-flex>
       <v-flex xs12 md12 p-b-10>
         <v-card class="boxShadow">
           <v-card-title primary-title class="p-b-none">
             <v-layout row>
               <v-flex left>
                 <div>
                   <strong class="text-primary">{{$t('label.receita')}}</strong>
                 </div>
               </v-flex>
               <v-flex right text-xs-right>
                 <v-btn icon @click="receitaShow = !receitaShow">
                   <v-icon>{{ !receitaShow ? 'keyboard_arrow_down' : 'keyboard_arrow_up'}}</v-icon>
                 </v-btn>
               </v-flex>
             </v-layout>
           </v-card-title>

           <v-slide-y-transition>
             <v-layout row wrap v-show="receitaShow" p-b-10>
               <v-flex xs12 sm4 md4>
                 <mascaraMoeda
                   :label="$t('label.capitalSocial')+testeAstericoEstrangeiro()"
                   :rules="[v=>validaIfObrigatorioBalanc2(v, validaBalancoFinanceiro02) || $t('messages.validacao.campoObrigatorio')]"
                   v-model="modelQualificacao.balancoFinanceiro.capitalSocial02"
                   :valorDefault="modelQualificacao.balancoFinanceiro.capitalSocial02"
                   required
                   validate-on-blur
                   :key="valorKey02"
                   :bloquearCampo="validaReadonlyBalanco02()">
                 </mascaraMoeda>
               </v-flex>

               <v-flex xs12 sm4 md4>
                 <mascaraMoeda
                   :label="$t('label.receitaOperacionalLiquida')+testeAstericoEstrangeiro()"
                   :rules="[v=>validaIfObrigatorioBalanc2(v, validaBalancoFinanceiro02) || $t('messages.validacao.campoObrigatorio')]"
                   v-model="modelQualificacao.balancoFinanceiro.receitaOpeLiquido02"
                   :valorDefault="modelQualificacao.balancoFinanceiro.receitaOpeLiquido02"
                   required
                   validate-on-blur
                   :key="valorKey02"
                   :bloquearCampo="validaReadonlyBalanco02()">
                 </mascaraMoeda>
               </v-flex>

               <v-flex xs12 sm4 md4>
                 <mascaraMoeda
                   :label="$t('label.receitaOperacionalBruta')+testeAstericoEstrangeiro()"
                   :rules="[v=>validaIfObrigatorio(v, validaBalancoFinanceiro02) || $t('messages.validacao.campoObrigatorio')]"
                   v-model="modelQualificacao.balancoFinanceiro.receitaOpeBruto02"
                   :valorDefault="modelQualificacao.balancoFinanceiro.receitaOpeBruto02"
                   required
                   validate-on-blur
                   :key="valorKey02"
                   :bloquearCampo="validaReadonlyBalanco02()">
                 </mascaraMoeda>
               </v-flex>
             </v-layout>
           </v-slide-y-transition>
         </v-card>
         <div class="p-b-10"></div>
       </v-flex>

       <v-flex xs12 md12 p-l-none p-r-none>
         <v-layout row wrap>
           <v-flex xs4 sm4 md4 class="p-b-10">
             <v-toolbar light>
               <v-toolbar-title>
                 {{$t('label.mediaFinanceira')}}:
                 <strong>{{formatarNumero(mediaFinanceira02)}}</strong>
               </v-toolbar-title>
               <v-spacer></v-spacer>
             </v-toolbar>
           </v-flex>
           <v-flex xs4 sm4 md4 class="p-b-10">
             <v-toolbar light>
               <v-toolbar-title>
                 {{$t('label.liquidezCorrente')}}:
                 <strong>{{formatarNumero(liquidezCorrente02)}}</strong>
               </v-toolbar-title>
               <v-spacer></v-spacer>
             </v-toolbar>
           </v-flex>
           <v-flex xs4 sm4 md4 class="p-b-10">
             <v-toolbar light>
               <v-toolbar-title>
                 {{$t('label.liquidezGeral')}}:
                 <strong>{{formatarNumero(liquidezGeral02)}}</strong>
               </v-toolbar-title>
               <v-spacer></v-spacer>
             </v-toolbar>
           </v-flex>
           <v-flex xs4 sm4 md4 class="p-b-10">
             <v-toolbar light>
               <v-toolbar-title>
                 {{$t('label.solvenciaGeral')}}:
                 <strong>{{formatarNumero(solvenciaGeral02)}}</strong>
               </v-toolbar-title>
               <v-spacer></v-spacer>
             </v-toolbar>
           </v-flex>
           
           <v-flex xs4 sm4 md4 class="p-b-10">
             <v-toolbar light>
               <v-toolbar-title>
                 {{$t('label.produtividade')}}:
                 <strong>{{formatarNumero(produtividade02)}}</strong>
               </v-toolbar-title>
               <v-spacer></v-spacer>
             </v-toolbar>
           </v-flex>
           <v-flex xs4 sm4 md4 class="p-b-10">
             <v-toolbar light>
               <v-toolbar-title>
                 {{$t('label.endividamento')}}:
                 <strong>{{formatarNumero(endividamento02)}}</strong>
               </v-toolbar-title>
               <v-spacer></v-spacer>
             </v-toolbar>
           </v-flex>
           <v-flex xs4 sm4 md4 class="p-b-10">
             <v-toolbar light>
               <v-toolbar-title>
                 {{$t('label.imobilizacaoCapitalProprio')}}:
                 <strong>{{formatarNumero(imobilizacaoCapitalProprio02,true)}}</strong>
               </v-toolbar-title>
               <v-spacer></v-spacer>
             </v-toolbar>
           </v-flex>
           <v-flex xs4 sm4 md4 class="p-b-10">
             <v-toolbar light>
               <v-toolbar-title>
                 {{$t('label.capitalizacao')}}:
                 <strong>{{formatarNumero(capitalizacao02,true)}}</strong>
               </v-toolbar-title>
               <v-spacer></v-spacer>
             </v-toolbar>
           </v-flex>
         </v-layout>
       </v-flex>
     </v-layout>

    <v-dialog v-model="dialogMigrarBalanco1Para2" persistent max-width="460px">
       <v-card style="width: 100%; overflow: hidden;">
         <v-card-title class="headline grey lighten-2" style="justify-content: center; padding: 12px 16px;">
           Migrar balanços
         </v-card-title>
         <v-card-text style="padding: 18px 16px 10px; white-space: normal; word-break: break-word; text-align: center;">
           O Balanço 01 ainda está válido. Deseja migrar os dados e o documento validados para o Balanço 02 e limpar os campos do Balanço 01?
         </v-card-text>
         <v-card-actions style="justify-content: center; flex-wrap: wrap; gap: 8px; padding: 0 16px 16px;">
           <v-btn small flat style="min-width: 96px; background-color: #ffebee !important; color: #b71c1c !important;" @click="cancelarMigracaoBalanco1Para2">Não</v-btn>
           <v-btn small color="primary" style="min-width: 128px;" @click="confirmarMigracaoBalanco1Para2">Sim, migrar</v-btn>
         </v-card-actions>
       </v-card>
     </v-dialog>

     <!-- final balanços financeiros -->

   </v-flex>
 </div>
</div>
</template>

<script>
import { event } from "jquery";
import util from "../../plugins/util"; /*Objeto com metodos e funcoes utilizadas pelo sistema */
import fornecedorService from "../../services/fornecedorService"; /*Objeto com os principais servicos de Fornecedor */
import moment from "moment";
export default {
 name: "qualificacao-economica",
 props: {//Propriedades que o objeto recebe como parametro
   model: Object, /*Solicitacao atual do Fornecedor*/
   enums: Object,
   modelQualificacao: Object,
   pontuacaoIndices: Array,
   totaisContas: Object,
   OldModel: Object,
   isAlteracao: Boolean
 },
 mixins: [util],
 created() /*Metodo de start do componente*/{
   //resgate das informacoes de quelificacao economica
   this.enums.situacaoDoc.unshift({
     chave: "-Selecione-",
     valor: null,
     descricao: "-Selecione-"
   });
  
   this.model.concordataFalencia = this.model.concordataFalencia
     ? this.model.concordataFalencia
     : {};
   this.model.balancoFinanceiro = this.model.balancoFinanceiro
     ? this.model.balancoFinanceiro
     : {};

   this.modelQualificacao.concordataFalencia = Object.assign(
     {},
     this.modelQualificacao.concordataFalencia,
     this.model.concordataFalencia
   );

   this.modelQualificacao.balancoFinanceiro = Object.assign(
     {},
     this.modelQualificacao.balancoFinanceiro,
     this.model.balancoFinanceiro
   );

this.modelQualificacao.balancoFinanceiro.anoBalanco2 = this.model.balancoFinanceiro.anoBalanco2
   
   this.modelQualificacao.concordataFalencia.novoUpload = this
     .modelQualificacao.concordataFalencia.arquivoUpload
     ? false
     : true;
   this.modelQualificacao.balancoFinanceiro.novoUpload = this.modelQualificacao
     .balancoFinanceiro.arquivoUpload
     ? false
     : true;
     this.modelQualificacao.balancoFinanceiro.novoUpload02 = this.modelQualificacao
     .balancoFinanceiro.arquivoUpload02
     ? false
     : true;

   this.modelQualificacao.concordataFalencia.limparArquivoUpload = false;
   this.modelQualificacao.balancoFinanceiro.limparArquivoUpload = false;
   this.modelQualificacao.balancoFinanceiro.limparArquivoUpload02 = false;

   this.modelQualificacao.balancoFinanceiro.identificador_balanco = 1;
   this.model.balancoFinanceiro.identificador_balanco = 1;

   this.validaConcodataFalencia = (!this.isAlteracao || (this.isAlteracao && !this.modelQualificacao.concordataFalencia.arquivoUpload))
   this.validaBalancoFinanceiro = (!this.isAlteracao || (this.isAlteracao && !this.modelQualificacao.balancoFinanceiro.arquivoUpload))
   this.validaBalancoFinanceiro02 = this.obrigarBalanco2();

    this.modelQualificacao.concordataFalencia.novoUpload = this
     .modelQualificacao.concordataFalencia.arquivoUpload
     ? false
     : true;
   this.modelQualificacao.balancoFinanceiro.novoUpload = this.modelQualificacao
     .balancoFinanceiro.arquivoUpload
     ? false
     : true;
   this.modelQualificacao.balancoFinanceiro.novoUpload02 = this.modelQualificacao
     .balancoFinanceiro.arquivoUpload02
     ? false
     : true;

     this.gerarAnos();
     this.gerarAnos2();

     this.ano = this.modelQualificacao.balancoFinanceiro.anoBalanco;
     this.ano2 = this.modelQualificacao.balancoFinanceiro.anoBalanco2;
  
     this.migra_B1_B2();
 },
 computed: {//Campos computados 
 },
 data() {//Declaracao de variaveis
   return {
     ativoShow: true,
     passivoShow: true,
     receitaShow: true,
     ativoNaoCirculante: 0,
     ativoNaoCirculante02: 0,
     ativoTotal: 0,
     ativoTotal02: 0,
     passivoNaoCirculante: 0,
     passivoNaoCirculante02: 0,
     passivoTotal: 0,
     passivoTotal02: 0,
     solvenciaGeral: 0,
     solvenciaGeral02: 0,
     liquidezCorrente: 0,
     liquidezCorrente02: 0,
     liquidezGeral: 0,
     liquidezGeral02: 0,
     produtividade: 0,
     produtividade02: 0,
     endividamento: 0,
     endividamento02: 0,
     capitalizacao: 0,
     capitalizacao02: 0,
     imobilizacaoCapitalProprio: 0,
     imobilizacaoCapitalProprio02: 0,
     mediaFinanceira: 0,
     mediaFinanceira02: 0,
     dtVencimentoKey: 1,
     dtVencimentoKey02: 1,
     dtEmissaoKey: 1,
     dtEmissaoKey02: 1,
     dtBalancoKey: 1,
     dtBalancoKey02: 1,
     valorKey: 1,
     valorKey02: 1,
     dataValidadeBalanco: null,
     dataValidadeBalanco02: null,
     dataValidadeBalancoKey: 1,
     dataValidadeBalancoKey02: 1,
     ano: null,
     ano2: null,
     anos: [],
     anos2: [],
     componentKey: 0, 
     componentKeyUp: 0,
     migrarBalancos: false,
     validarAno: null,
     dialogMigrarBalanco1Para2: false,
     migracaoBalanco1Para2Confirmada: false,
     esta_homologando: true,
     jaMigrou: true
   };
 },
 watch: { //Propriedades assistidas  
   "modelQualificacao.balancoFinanceiro": {
     handler() {
       this.calcAtivos();
       this.calcPassivos();
       this.calcSolvencia();
       this.calcLiqCorrente();
       this.calcLiqGeral();
       this.calcProdutividade();
       this.calcEndividamento();
       this.calcICP();
       this.calcCapitalizacao();
       this.calcMediaFinanceira();
     },
     deep: true
   }
 },

 methods: {//Declaracao de todos os metodos 
  pegaDataAtual() {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Mês é baseado em zero
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  },
  zeroPad(num) {
    return num.toString().padStart(2, '0');
},
  parseDateSeguro(value) {
    if (!value) return null;

    if (value instanceof Date) {
      return isNaN(value.getTime()) ? null : new Date(value.getTime());
    }

    if (typeof value === 'string') {
      if (value.includes('-') || value.includes('/')) {
        const parsed = new Date(value);
        return isNaN(parsed.getTime()) ? null : parsed;
      }
    }

    const fallback = new Date(value);
    return isNaN(fallback.getTime()) ? null : fallback;
  },
  anularCamposBalanco() {
    
     const anoAtual = new Date().getFullYear();
      const anoBalanco = new Date(this.modelQualificacao.balancoFinanceiro.dtBalanco).getFullYear();

      const hoje = new Date();
      hoje.setHours(0, 0, 0, 0);

      const dtValidade = new Date(this.modelQualificacao.balancoFinanceiro.dtValidadeBalanco);
      dtValidade.setHours(0, 0, 0, 0);

      if (this.model.balancoFinanceiro.arquivoUpload && this.model.balancoFinanceiro.arquivoUpload.includes('https')
      && this.model.balancoFinanceiro.arquivoUpload != this.model.balancoFinanceiro.arquivoUpload02
      && this.obrigarBalanco2() !== 'Nobrigabalanco2' && anoBalanco < anoAtual - 1 && dtValidade < hoje
      ) {
        this.migrarBalancos = true;
    // this.modelQualificacao.balancoFinanceiro.anoBalanco2 = this.model.balancoFinanceiro.anoBalanco;
        this.$nextTick(() => {
          this.$set(this.modelQualificacao.balancoFinanceiro, 'anoBalanco2', this.model.balancoFinanceiro.anoBalanco);
        });
        this.modelQualificacao.balancoFinanceiro.anoBalanco2 = this.modelQualificacao.balancoFinanceiro.anoBalanco;        
        this.modelQualificacao.balancoFinanceiro.numLivroDiario02 = this.modelQualificacao.balancoFinanceiro.numLivroDiario;
        this.model.balancoFinanceiro.dtBalanco02 = this.modelQualificacao.balancoFinanceiro.dtBalanco;
        this.model.balancoFinanceiro.arquivoUpload02 = this.model.balancoFinanceiro.arquivoUpload;
        this.modelQualificacao.balancoFinanceiro.dtBalanco02 = this.modelQualificacao.balancoFinanceiro.dtBalanco;
        this.modelQualificacao.balancoFinanceiro.arquivoUpload02 = this.modelQualificacao.balancoFinanceiro.arquivoUpload;
        this.modelQualificacao.balancoFinanceiro.arquivoUploadSituacao02 = this.modelQualificacao.balancoFinanceiro.arquivoUploadSituacao;

        const anoVigente = new Date().getFullYear();
        const ultimoDiaUtilDeJunho = this.getUltimoDiaUtilDeJunho(anoVigente + 1);
        const novaDataVencimento = new Date(`${anoVigente + 1}-06-${this.zeroPad(ultimoDiaUtilDeJunho)}T00:00:00`).toISOString(); 
       
        // Atualiza B1 e B2
      //   this.modelQualificacao.balancoFinanceiro.dtValidadeBalanco = novaDataVencimento;
        this.modelQualificacao.balancoFinanceiro.dtValidadeBalanco02 = novaDataVencimento;
    
        //this.modelQualificacao.balancoFinanceiro.dtValidadeBalanco02 = dataISO;
        this.modelQualificacao.balancoFinanceiro.ativoCirculante02 = this.modelQualificacao.balancoFinanceiro.ativoCirculante;
        this.modelQualificacao.balancoFinanceiro.realizavelLP02 = this.modelQualificacao.balancoFinanceiro.realizavelLP;
        this.modelQualificacao.balancoFinanceiro.investimento02 = this.modelQualificacao.balancoFinanceiro.investimento;
        this.modelQualificacao.balancoFinanceiro.imobilizado02 = this.modelQualificacao.balancoFinanceiro.imobilizado;
        this.modelQualificacao.balancoFinanceiro.intangivel02 = this.modelQualificacao.balancoFinanceiro.intangivel;
        this.modelQualificacao.balancoFinanceiro.passivoCirculante02 = this.modelQualificacao.balancoFinanceiro.passivoCirculante;
        this.modelQualificacao.balancoFinanceiro.exigivelLP02 = this.modelQualificacao.balancoFinanceiro.exigivelLP;
        this.modelQualificacao.balancoFinanceiro.resultExerciciosFut02 = this.modelQualificacao.balancoFinanceiro.resultExerciciosFut;
        this.modelQualificacao.balancoFinanceiro.patrimonioLiquido02 = this.modelQualificacao.balancoFinanceiro.patrimonioLiquido;
        this.modelQualificacao.balancoFinanceiro.capitalSocial02 = this.modelQualificacao.balancoFinanceiro.capitalSocial;
        this.modelQualificacao.balancoFinanceiro.receitaOpeLiquido02 = this.modelQualificacao.balancoFinanceiro.receitaOpeLiquido;
        this.modelQualificacao.balancoFinanceiro.receitaOpeBruto02 = this.modelQualificacao.balancoFinanceiro.receitaOpeBruto;        
        this.modelQualificacao.balancoFinanceiro.novoUpload02 = false;

        let dataCompAtual = this.pegaDataAtual();
        let anoCorrente = dataCompAtual.slice(0, 4);
        this.modelQualificacao.balancoFinanceiro.anoBalanco = anoCorrente - 1; // ano corrente - 1

        // Anulando campos do balanço 01
        this.modelQualificacao.balancoFinanceiro.numLivroDiario = null;
        this.modelQualificacao.balancoFinanceiro.dtBalanco = null;
        //this.model.balancoFinanceiro.dtBalanco = null;
        // this.model.balancoFinanceiro.arquivoUpload = null;
        this.modelQualificacao.balancoFinanceiro.novoUpload = true;
        this.modelQualificacao.balancoFinanceiro.ativoCirculante = null;
        this.modelQualificacao.balancoFinanceiro.realizavelLP = null;
        this.modelQualificacao.balancoFinanceiro.investimento = null;
        this.modelQualificacao.balancoFinanceiro.imobilizado = null;
        this.modelQualificacao.balancoFinanceiro.intangivel = null;
        this.modelQualificacao.balancoFinanceiro.passivoCirculante = null;
        this.modelQualificacao.balancoFinanceiro.exigivelLP = null;
        this.modelQualificacao.balancoFinanceiro.resultExerciciosFut = null;
        this.modelQualificacao.balancoFinanceiro.patrimonioLiquido = null;
        this.modelQualificacao.balancoFinanceiro.capitalSocial = null;
        this.modelQualificacao.balancoFinanceiro.receitaOpeLiquido = null;
        this.modelQualificacao.balancoFinanceiro.receitaOpeBruto = null;
        this.modelQualificacao.balancoFinanceiro.dtValidadeBalanco = null;
    }
  },
  isValidURL(string) {
    try {
      new URL(string);
      return true;
    } catch (_) {
      return false;
    }
  },
  migra_B1_B2() {
    const dataValB1 = this.model.balancoFinanceiro.dtValidadeBalanco; // data no formato "2025-06-30T03:00:00"
const hoje = new Date(); // Data atual
const dataValidade = new Date(dataValB1);

// Zera as horas de hoje e de dataValidade para comparação correta
hoje.setHours(0, 0, 0, 0);
dataValidade.setHours(0, 0, 0, 0);

const anoAtual = hoje.getFullYear();
const dataInicioPrimeiroSemestre = new Date(anoAtual, 0, 1); // 01/01 do ano atual
const dataFimPrimeiroSemestre = new Date(anoAtual, 5, 30); // 30/06 do ano atual
const dataJunhoAnoSeguinte = new Date(anoAtual + 1, 5, 30); // 30/06 do ano seguinte

// Zera as horas das datas comparativas também
dataInicioPrimeiroSemestre.setHours(0, 0, 0, 0);
dataFimPrimeiroSemestre.setHours(0, 0, 0, 0);
dataJunhoAnoSeguinte.setHours(0, 0, 0, 0);

// Verifica as condições em um único if
    
if (
    // Verifica se está no primeiro semestre, dataValidade é do ano anterior e é menor que hoje
    (hoje >= dataInicioPrimeiroSemestre && hoje <= dataFimPrimeiroSemestre && 
     dataValidade < hoje && dataValidade.getFullYear() === hoje.getFullYear() - 1) ||
    
    // Verifica se está no segundo semestre, dataValidade é do ano atual e não é igual a 30/06 do próximo ano

    (hoje > dataFimPrimeiroSemestre &&   dataValidade < hoje     &&
     dataValidade.getFullYear() === hoje.getFullYear())    
) {  
          
          var urlBal01 = this.model.balancoFinanceiro.arquivoUpload;
          if (this.isValidURL(urlBal01)) {
            // Criar um objeto URL
            var urlObj01 = new URL(urlBal01);
            // Obter os parâmetros de consulta
            var params01 = new URLSearchParams(urlObj01.search);
            // Extrair o valor do parâmetro 'infra_hash'
            var infraHashBal01 = params01.get('infra_hash');
          }
          
          const confereMigracao = localStorage.getItem('LS_hashArquivoBalanco01');
    
   
          if (this.model.balancoFinanceiro.arquivoUpload && this.model.balancoFinanceiro.arquivoUpload.includes("https")) {
              this.anularCamposBalanco();
          }
          if(infraHashBal01 == confereMigracao) {
         //   this.anularCamposBalanco();            
          }
          
          if(confereMigracao === null) {       
          // this.anularCamposBalanco();
            localStorage.setItem('LS_hashArquivoBalanco01', infraHashBal01);
          }          
        }             
  },
      validarUploadBalanco02() {
          const livro = this.modelQualificacao.balancoFinanceiro.numLivroDiario02;
          const data = this.modelQualificacao.balancoFinanceiro.dtBalanco02;
          const arquivo = this.model.balancoFinanceiro.arquivoUpload02;

          if ((livro || data) && !arquivo) {
            return false;
          }
          return true;
        },
   validaAnoValido(ano, balanco) {
       let getAno = Number(ano);
       let anosValidos = balanco === 2 ? this.anos2 : this.anos;

       if (!this.validarAno) {
           return true;  // Não valida até que o valor seja setado
       }
       if (balanco === 2 && this.modelQualificacao.concordataFalencia.arquivoUpload02 == null){
         
         return true;
       }
       if (anosValidos.includes(getAno)) {
           return true;
       } else {
           if (balanco === 1) {
               this.modelQualificacao.balancoFinanceiro.anoBalanco = null;
           } else if (balanco === 2) {
               this.modelQualificacao.balancoFinanceiro.anoBalanco2 = null;
           }
           return false;
       }
   },
   gerarAnos() {
     const anoAtual = new Date().getFullYear();
     this.anos = [anoAtual, anoAtual - 1, anoAtual - 2];
   },
   gerarAnos2() {
     const anoAtual = new Date().getFullYear();
     this.anos2 = [ anoAtual - 2, anoAtual - 3];
   },
   /*
   obrigaValidaFinalMaio() {
     // Data abertura da empresa
     const dataAbertEmp = this.model.regularidadeFiscTrab[0].dtAberturaEmpresa;

     // 2022-02-02
     var dataAMD = dataAbertEmp.substring(0, 10);

     // Ano abertura da empresa
     var anoAberturaEmp = dataAbertEmp.substring(0, 4);

     var dataAtual = moment();
     const anoCorrente = dataAtual.format('YYYY');

     const dataLimiteMaio = anoCorrente + '-' + '05' + '-' + '31';      

     const dataLimite = moment(dataLimiteMaio);      

     var dataAtual = moment();

     dataAtual = dataAtual.format('YYYY-MM-DD');

     // Comparando as datas
     if (dataAtual > dataLimiteMaio) {
       return false;
     } else if (dataAtual < dataLimiteMaio) {
       return true;
     }
   },
   */

   obrigarBalanco2() {
    let regularidadeFiscTrabAberturaEmp = this.model.regularidadeFiscTrab.find(
        x => x.tipDocumento === 1
    );

    if (!regularidadeFiscTrabAberturaEmp || !regularidadeFiscTrabAberturaEmp.dtAberturaEmpresa) {
        return 'semBalanco2'; // Se não houver data de abertura, não obriga
    }

    const balanco = this.modelQualificacao.balancoFinanceiro;

    const camposObrigatorios02 = Object.keys(balanco).filter(key =>
      key.endsWith('02') &&
      key !== 'dtValidadeBalanco02' &&  key !== 'codDocumentoSIMPAS02' &&  key !== 'limparArquivoUpload02'
      &&  key !== 'novoUpload02'  &&  key !== 'numDocumentoSEI02'
    );

    const algumCampoPreenchidoEValido = camposObrigatorios02.some(key => {
      const valor = balanco[key];

      // Se for campo de data, verificar validade com moment
      if (key.toLowerCase().startsWith('dt') && typeof valor === 'string') {
        const data = moment(valor, moment.ISO_8601, true);
        return data.isValid();
      }

      // Ignorar valores considerados "não preenchidos"
      if (
        valor === null ||
        valor === undefined ||
        valor === '' ||
        valor === 0 ||
        valor === '0' ||
        valor === '0.00'
      ) {
        return false;
      }

      return true;
    });

    if (algumCampoPreenchidoEValido && !balanco.arquivoUpload02) {
      return 'obrigabalanco2';
    }


    // Ajustando a data de abertura se estiver entre 15/12 e 31/12
    let dataAbertura = moment(regularidadeFiscTrabAberturaEmp.dtAberturaEmpresa);
    if (dataAbertura.isBetween(`${dataAbertura.year()}-12-15`, `${dataAbertura.year()}-12-31`, null, '[]')) {
        dataAbertura.add(1, 'year').startOf('year');
    }

    let dataDoisAnos = dataAbertura.clone().add(2, 'years');
    let dataAtual = moment(); // Data do dia atual

    // Caso a empresa tenha menos de 2 anos, nunca obriga
    if (dataAtual.isBefore(dataDoisAnos)) {
        return 'Nobrigabalanco2';
    }

    // Calcula o último dia útil de junho do ano atual
    let ultimoDiaUtilJunho = moment(`${dataAtual.year()}-06-30`);
    if (ultimoDiaUtilJunho.day() === 6) {
        ultimoDiaUtilJunho.subtract(1, 'days'); // Se for sábado, volta para sexta
    } else if (ultimoDiaUtilJunho.day() === 0) {
        ultimoDiaUtilJunho.subtract(2, 'days'); // Se for domingo, volta para sexta
    }

    // Se completou 2 anos no primeiro semestre e ainda não passou do último dia útil de junho
    if (dataDoisAnos.year() === dataAtual.year() &&
        dataDoisAnos.month() < 6 &&
        dataAtual.isBefore(ultimoDiaUtilJunho)
    ) {
        return 'Nobrigabalanco2';
    }

    return 'obrigabalanco2'; // Se já passou do prazo, exige normalmente
},


   validaAnoAnterior(data, quantosAnos) {

     if (this.obrigarBalanco2() != 'obrigabalanco2' && (this.modelQualificacao.balancoFinanceiro.file02 === undefined || this.modelQualificacao.balancoFinanceiro.file02 === null) && quantosAnos == 2) {
      
      return true;
     }    
  
     let regularidadeFiscTrabAberturaEmp = this.model.regularidadeFiscTrab.find(x => x.tipDocumento === 1);
     const a = moment(regularidadeFiscTrabAberturaEmp.dtAberturaEmpresa).year();
     const b = moment(this.model.dataSolicitacao);

     

     if (data === '' && (this.modelQualificacao.balancoFinanceiro.file02 === null && this.obrigarBalanco2() != 'obrigabalanco2')) {
       return true;
     } else {
      const anoAtual = new Date().getFullYear();
          const partesData = data.split('/');
          const dataConvertida = new Date(`${partesData[2]}-${partesData[1]}-${partesData[0]}`);
          const anoData = dataConvertida.getFullYear();
          const mesAtual = new Date().getMonth() + 1; // Janeiro = 0
          const primeiroSemestre = mesAtual <= 6;

          // Verificar se é Balanço 01
          if (quantosAnos === 1) {
            if(a === anoData){
              return true;
            }
            if (primeiroSemestre) {
              // Primeiro semestre: ano pode ser do ano anterior ou dois anos antes
              return anoData === anoAtual - 1 || anoData === anoAtual - 2;
            } else {
              // Segundo semestre: ano pode ser apenas do ano anterior
              return anoData === anoAtual - 1;
            }
          }

          // Verificar se é Balanço 02
          if (quantosAnos === 2) {
            if (primeiroSemestre) {
              // Primeiro semestre: ano pode ser dois ou três anos antes
              return anoData === anoAtual - 2 || anoData === anoAtual - 3;
            } else {
              // Segundo semestre: ano pode ser apenas dois anos antes
              return anoData === anoAtual - 2;
            }
          }

          return false; // Caso nenhum dos cenários seja válido
            }
   },

   getPreviousYear(param) {
     const currentDate = new Date();
     const currentYear = currentDate.getFullYear();
     const currentMonth = currentDate.getMonth() + 1; // +1 pois o mês começa em 0 (janeiro) e vai até 11 (dezembro)

     // Se a data atual for maior ou igual a 1 de junho (mês 6), use a regra normal
     if (currentMonth >= 6) {
       return currentYear - param;
     } else {
       // Se a data atual for antes de 1 de junho, subtraia o parâmetro e mais 1
       return currentYear - param - 1;
     }
   },
   getUltimoDiaUtilDeJunho(ano) {
      let data = new Date(ano, 5, 30); // Mês 5 = junho (mês começa em 0)
      
      // Enquanto o dia não for útil (segunda a sexta), vai voltando um dia
      while (data.getDay() === 0 || data.getDay() === 6) {
        data.setDate(data.getDate() - 1);
      }
      
      return data.getDate(); // Retorna o dia do mês (1 a 31)
  },
   testeAstericoEstrangeiro() {
     //testar obrigatoriedade quando é ou nao estrangeiro
     if (
       !(
         this.model.tipoCertificado === 2 && // tipoCertificado é do tipo number
         (this.model.tipFornecedor === "J" || this.model.tipFornecedor === "F")
       ) &&
       this.model.flagEstrangeiro === '0'
     )
       return " *";
     else return "";
   },
   validaIfObrigatorio(v, valor) {

       if (valor === 'situacaoDoc' && v == 0){
         return true;
       } else if (
         !(
           this.model.tipoCertificado === 2 && // tipoCertificado é do tipo number
           (this.model.tipFornecedor === "J" || this.model.tipFornecedor === "F")
         ) &&
         this.model.flagEstrangeiro === '0'
       ) {
         return !!v;
       } else {
         return true;
       }
   },
   validaIfObrigatorioBalanc2(v, valor) {
    
 
            
     if(this.obrigarBalanco2() === 'Nobrigabalanco2' ){
       return true;       
      }
      else{
          if (valor === 'situacaoDoc' && v == 0){
         return true;
       } else if (
         !(
           this.model.tipoCertificado === 2 && // tipoCertificado é do tipo number
           (this.model.tipFornecedor === "J" || this.model.tipFornecedor === "F")
         ) &&
         this.model.flagEstrangeiro === '0'
       ) {
         return !!v;
       } else {
         return true;
       }
      }
      
   },
   
   editarConcordata() {//Declaracao de variaveis
     //limpar a concordata pra editar
     if (this.isAlteracao) {
       this.modelQualificacao.concordataFalencia.numDocumento = null;
       this.modelQualificacao.concordataFalencia.dtEmissao = null;
       this.modelQualificacao.concordataFalencia.dtVencimento = null;
       this.modelQualificacao.concordataFalencia.situacaoDoc = null;
       this.modelQualificacao.concordataFalencia.codControle = null;
       this.modelQualificacao.concordataFalencia.arquivoUpload = null;
       this.modelQualificacao.concordataFalencia.novoUpload = true;
       this.modelQualificacao.concordataFalencia.arquivoUploadSituacao = null;

       this.model.concordataFalencia.dtEmissao = null;
       this.model.concordataFalencia.dtVencimento = null;
       this.model.concordataFalencia.arquivoUpload = null;
       this.model.concordataFalencia.arquivoUploadSituacao = null;
       
       
       // this.modelQualificacao.concordataFalencia.numDocumento02 = null;
       // this.modelQualificacao.concordataFalencia.dtEmissao02 = null;
       // this.modelQualificacao.concordataFalencia.dtVencimento02 = null;
       // this.modelQualificacao.concordataFalencia.situacaoDoc02 = null;
       // this.modelQualificacao.concordataFalencia.codControle02 = null;
       // this.modelQualificacao.concordataFalencia.arquivoUpload02 = null;
       // this.modelQualificacao.concordataFalencia.novoUpload02 = true;
       // this.modelQualificacao.concordataFalencia.arquivoUploadSituacao02 = null;

       // this.model.concordataFalencia.dtEmissao02 = null;
       // this.model.concordataFalencia.dtVencimento02 = null;
       // this.model.concordataFalencia.arquivoUpload02 = null;
       // this.model.concordataFalencia.arquivoUploadSituacao02 = null;

       this.dtVencimentoKey++;
       this.dtEmissaoKey++;
     }
   },
     MudarBalanco1Para2(){

        const temArquivoMigravel = this.model.balancoFinanceiro.arquivoUpload && this.model.balancoFinanceiro.arquivoUpload.includes('https')
        && this.model.balancoFinanceiro.arquivoUpload != this.model.balancoFinanceiro.arquivoUpload02;

        if (
          temArquivoMigravel &&
          this.deveConfirmarMigracaoBalanco1Para2() &&
          !this.migracaoBalanco1Para2Confirmada
        ) {
          this.dialogMigrarBalanco1Para2 = true;
          return;
        }

        this.migracaoBalanco1Para2Confirmada = false;

        if (temArquivoMigravel) {
     this.$refs.dtBalanco02.date = this.$refs.dtBalanco.date;
     this.modelQualificacao.balancoFinanceiro.dtBalanco02 = this.modelQualificacao.balancoFinanceiro.dtBalanco;

       // Limpar o valor de dtBalanco
       this.modelQualificacao.balancoFinanceiro.dtBalanco = '';

       // Verificar se o componente de data tem um método de reset
       this.$nextTick(() => {  
           const inputElement = this.$refs.dtBalanco.$el.querySelector('input');
           if (inputElement) {
             inputElement.value = '';
             inputElement.dispatchEvent(new Event('input'));
           }  
       });

     this.modelQualificacao.balancoFinanceiro.numLivroDiario02 = this.modelQualificacao.balancoFinanceiro.numLivroDiario;
     this.modelQualificacao.balancoFinanceiro.numLivroDiario = null;
  
     

      this.modelQualificacao.balancoFinanceiro.file02 = this.model.balancoFinanceiro.arquivoUpload;
      this.model.balancoFinanceiro.arquivoUpload02 = this.model.balancoFinanceiro.arquivoUpload;
      this.modelQualificacao.balancoFinanceiro.arquivoUpload02 = this.modelQualificacao.balancoFinanceiro.arquivoUpload;
      this.modelQualificacao.balancoFinanceiro.arquivoUploadSituacao02 = this.modelQualificacao.balancoFinanceiro.arquivoUploadSituacao;
      this.modelQualificacao.balancoFinanceiro.novoUpload02 = false;

      
       this.modelQualificacao.balancoFinanceiro.arquivoUploadSituacao = null;
       this.modelQualificacao.balancoFinanceiro.novoUpload = true;
       this.modelQualificacao.balancoFinanceiro.file = null;
      // this.model.balancoFinanceiro.arquivoUpload = null;
       this.modelQualificacao.balancoFinanceiro.limparArquivoUpload = true;

    
       this.model.balancoFinanceiro.dtBalanco02 = this.model.balancoFinanceiro.dtBalanco;

     this.modelQualificacao.balancoFinanceiro.ativoCirculante02 = this.modelQualificacao.balancoFinanceiro.ativoCirculante;
      
    //  const anoVigente = new Date().getFullYear();
    //  const ultimoDiaUtilDeJunho = this.getUltimoDiaUtilDeJunho(anoVigente + 1);
    //  const novaDataVencimento = new Date(`${anoVigente + 1}-06-${this.zeroPad(ultimoDiaUtilDeJunho)}T00:00:00`).toISOString();
    
    // ---------------------------------------------------------------------
    // ✅ REGRA NOVA (frontend):
    // validade = último dia útil de junho do ano seguinte ao ano do balanço
    // Base: dtBalanco02 (pois dtBalanco foi limpo)
    // ---------------------------------------------------------------------
    var dtBalancoStr =
      (this.modelQualificacao &&
       this.modelQualificacao.balancoFinanceiro &&
       this.modelQualificacao.balancoFinanceiro.dtBalanco02)
        ? this.modelQualificacao.balancoFinanceiro.dtBalanco02
        : null;

    var novaDataVencimento = null;

    if (dtBalancoStr) {
      var anoBalancoRef = new Date(dtBalancoStr).getFullYear();
      var anoValidade = anoBalancoRef + 1;

      var ultimoDiaUtilDeJunho = this.getUltimoDiaUtilDeJunho(anoValidade);

      novaDataVencimento = new Date(
        anoValidade + "-06-" + this.zeroPad(ultimoDiaUtilDeJunho) + "T00:00:00"
      ).toISOString();

      // Atualiza B1 e B2 (mantendo seu comportamento)
      this.modelQualificacao.balancoFinanceiro.dtValidadeBalanco = novaDataVencimento;

      if (this.modelQualificacao.balancoFinanceiro.arquivoUpload02 != null) {
        this.modelQualificacao.balancoFinanceiro.dtValidadeBalanco02 = novaDataVencimento;
      }

      // garante o valor em B2 (como você já vinha fazendo)
      this.modelQualificacao.balancoFinanceiro.dtValidadeBalanco02 = novaDataVencimento;
    } else {
      // Sem base de data, não calcula
      this.modelQualificacao.balancoFinanceiro.dtValidadeBalanco = null;
    }
    // ---------------------------------------------------------------------

    //  // Atualiza B1 e B2
    //  this.modelQualificacao.balancoFinanceiro.dtValidadeBalanco = novaDataVencimento;

    //  if(this.modelQualificacao.balancoFinanceiro.arquivoUpload02 != null){
    //   this.modelQualificacao.balancoFinanceiro.dtValidadeBalanco02 = novaDataVencimento;
    //  }
   
    //  this.modelQualificacao.balancoFinanceiro.dtValidadeBalanco02 = novaDataVencimento;
     
     
     this.modelQualificacao.balancoFinanceiro.ativoNaoCirculante02 = this.modelQualificacao.balancoFinanceiro.ativoNaoCirculante;
     this.modelQualificacao.balancoFinanceiro.realizavelLP02 = this.modelQualificacao.balancoFinanceiro.realizavelLP;
     this.modelQualificacao.balancoFinanceiro.investimento02 = this.modelQualificacao.balancoFinanceiro.investimento;
     this.modelQualificacao.balancoFinanceiro.imobilizado02 = this.modelQualificacao.balancoFinanceiro.imobilizado;
     this.modelQualificacao.balancoFinanceiro.intangivel02 = this.modelQualificacao.balancoFinanceiro.intangivel;
     this.modelQualificacao.balancoFinanceiro.ativoTotal02 = this.modelQualificacao.balancoFinanceiro.ativoTotal;
     this.modelQualificacao.balancoFinanceiro.passivoCirculante02 = this.modelQualificacao.balancoFinanceiro.passivoCirculante;
     this.modelQualificacao.balancoFinanceiro.passivoNaoCirculante02 = this.modelQualificacao.balancoFinanceiro.passivoNaoCirculante;
     this.modelQualificacao.balancoFinanceiro.exigivelLP02 = this.modelQualificacao.balancoFinanceiro.exigivelLP;
     this.modelQualificacao.balancoFinanceiro.resultExerciciosFut02 = this.modelQualificacao.balancoFinanceiro.resultExerciciosFut;
     this.modelQualificacao.balancoFinanceiro.patrimonioLiquido02 = this.modelQualificacao.balancoFinanceiro.patrimonioLiquido;
     this.modelQualificacao.balancoFinanceiro.passivoTotal02 = this.modelQualificacao.balancoFinanceiro.passivoTotal;
     this.modelQualificacao.balancoFinanceiro.capitalSocial02 = this.modelQualificacao.balancoFinanceiro.capitalSocial;
     this.modelQualificacao.balancoFinanceiro.receitaOpeLiquido02 = this.modelQualificacao.balancoFinanceiro.receitaOpeLiquido;
     this.modelQualificacao.balancoFinanceiro.receitaOpeBruto02 = this.modelQualificacao.balancoFinanceiro.receitaOpeBruto;
     this.mediaFinanceira02 = this.mediaFinanceira;
     this.liquidezCorrente02 = this.liquidezCorrente;
     this.liquidezGeral02 = this.liquidezGeral;
     this.solvenciaGeral02 = this.solvenciaGeral;
    
     this.endividamento02 = this.endividamento;
     this.imobilizacaoCapitalProprio02 = this.imobilizacaoCapitalProprio;
     this.capitalizacao02 = this.capitalizacao;
   
       this.produtividade02 = this.produtividade;
             
       this.modelQualificacao.balancoFinanceiro.anoBalanco2 = this.ano;
      

     // Limpar valores
    // this.model.balancoFinanceiro.arquivoUpload = null;
    // ✅ Mantém validade do Balanço 1 após migração (regra nova)
     this.model.balancoFinanceiro.dtValidadeBalanco = this.modelQualificacao.balancoFinanceiro.dtValidadeBalanco;
    //  this.modelQualificacao.balancoFinanceiro.dtValidadeBalanco = null;
    //  this.model.balancoFinanceiro.dtValidadeBalanco = null;
     this.modelQualificacao.balancoFinanceiro.ativoCirculante = null;
     this.modelQualificacao.balancoFinanceiro.ativoNaoCirculante = null;
     this.modelQualificacao.balancoFinanceiro.realizavelLP = null;
     this.modelQualificacao.balancoFinanceiro.investimento = null;
     this.modelQualificacao.balancoFinanceiro.imobilizado = null;
     this.modelQualificacao.balancoFinanceiro.intangivel = null;
     this.modelQualificacao.balancoFinanceiro.ativoTotal = null;
     this.modelQualificacao.balancoFinanceiro.passivoCirculante = null;
     this.modelQualificacao.balancoFinanceiro.passivoNaoCirculante = null;
     this.modelQualificacao.balancoFinanceiro.exigivelLP = null;
     this.modelQualificacao.balancoFinanceiro.resultExerciciosFut = null;
     this.modelQualificacao.balancoFinanceiro.patrimonioLiquido = null;
     this.modelQualificacao.balancoFinanceiro.passivoTotal = null;
     this.modelQualificacao.balancoFinanceiro.capitalSocial = null;
     this.modelQualificacao.balancoFinanceiro.receitaOpeLiquido = null;
     this.modelQualificacao.balancoFinanceiro.receitaOpeBruto = null;
     this.mediaFinanceira = null;
     this.liquidezCorrente = null;
     this.liquidezGeral = null;
     this.solvenciaGeral = null;
     this.produtividade = null;
     this.endividamento = null;
     this.imobilizacaoCapitalProprio = null;
     this.capitalizacao = null;


     this.calcMediaFinanceira();
    
     this.componentKey += 1;
     this.componentKeyUp += 1;
     this.$forceUpdate();
       }
      
     },
   deveConfirmarMigracaoBalanco1Para2() {
     const dtValidadeBalanco = this.parseDateSeguro(this.modelQualificacao.balancoFinanceiro.dtValidadeBalanco);

     if (!dtValidadeBalanco) {
       return false;
     }

     const hoje = new Date();
     hoje.setHours(0, 0, 0, 0);
     dtValidadeBalanco.setHours(0, 0, 0, 0);

     return dtValidadeBalanco >= hoje;
   },
   confirmarMigracaoBalanco1Para2() {
     this.dialogMigrarBalanco1Para2 = false;
     this.migracaoBalanco1Para2Confirmada = true;
     this.MudarBalanco1Para2();
   },
   cancelarMigracaoBalanco1Para2() {
     this.dialogMigrarBalanco1Para2 = false;
     this.migracaoBalanco1Para2Confirmada = false;
   },
   validaReadonlyConcordata() {//Declaracao de variaveis
     //verificar se é pra deixaar readonly a concordata
     var retorno = false;

     // if (this.isAlteracao) {
     //   if (this.modelQualificacao.concordataFalencia.novoUpload) {
     //     return false;
     //   } else {
     //     return true;
     //   }
     // }
     return retorno;
   },
   editarBalanco() {
     //limpar o balanco para editar
     if (this.isAlteracao) {
    
       this.modelQualificacao.balancoFinanceiro.numLivroDiario = null;
       this.modelQualificacao.balancoFinanceiro.dtBalanco = null;
       this.modelQualificacao.balancoFinanceiro.dtValidadeBalanco = null;
       this.modelQualificacao.balancoFinanceiro.arquivoUpload = null;
       this.modelQualificacao.balancoFinanceiro.novoUpload = true;
       this.modelQualificacao.balancoFinanceiro.arquivoUploadSituacao = null;

       this.model.balancoFinanceiro.dtBalanco = null;
       this.model.balancoFinanceiro.arquivoUpload = null;
       this.model.balancoFinanceiro.dtValidadeBalanco = null;
       this.model.balancoFinanceiro.arquivoUploadSituacao = null;


       //Ativo
       this.modelQualificacao.balancoFinanceiro.ativoCirculante = 0;
       this.modelQualificacao.balancoFinanceiro.realizavelLP = 0;
       this.modelQualificacao.balancoFinanceiro.investimento = 0;
       this.modelQualificacao.balancoFinanceiro.imobilizado = 0;
       this.modelQualificacao.balancoFinanceiro.intangivel = 0;

       //passivo
       this.modelQualificacao.balancoFinanceiro.passivoCirculante = 0;
       this.modelQualificacao.balancoFinanceiro.exigivelLP = 0;
       this.modelQualificacao.balancoFinanceiro.resultExerciciosFut = 0;
       this.modelQualificacao.balancoFinanceiro.patrimonioLiquido = 0;

       //Receita
       this.modelQualificacao.balancoFinanceiro.capitalSocial = 0;
       this.modelQualificacao.balancoFinanceiro.receitaOpeLiquido = 0;
       this.modelQualificacao.balancoFinanceiro.receitaOpeBruto = 0;

       this.dtBalancoKey++;
       this.valorKey++;
       this.dataValidadeBalancoKey++;
     }
   },
   editarBalanco2() {
     //limpar o balanco para editar
     if (this.isAlteracao) {

       this.modelQualificacao.balancoFinanceiro.numLivroDiario02 = null;
       this.modelQualificacao.balancoFinanceiro.dtBalanco02 = null;
       this.modelQualificacao.balancoFinanceiro.dtValidadeBalanco02 = null;
    
       this.modelQualificacao.balancoFinanceiro.arquivoUpload02 = null;
       this.modelQualificacao.balancoFinanceiro.novoUpload02= true;
       this.modelQualificacao.balancoFinanceiro.arquivoUploadSituacao02 = null;

       this.model.balancoFinanceiro.dtBalanco02 = null;
       this.model.balancoFinanceiro.arquivoUpload02 = null;
       this.model.balancoFinanceiro.dtValidadeBalanco02 = null;
       this.model.balancoFinanceiro.arquivoUploadSituacao02 = null;
       this.modelQualificacao.balancoFinanceiro.file02 = null;
       this.model.balancoFinanceiro.anoBalanco2 = null;


       //Ativo

       this.modelQualificacao.balancoFinanceiro.ativoCirculante02 = 0;
       this.modelQualificacao.balancoFinanceiro.realizavelLP02 = 0;
       this.modelQualificacao.balancoFinanceiro.investimento02 = 0;
       this.modelQualificacao.balancoFinanceiro.imobilizado02 = 0;
       this.modelQualificacao.balancoFinanceiro.intangivel02 = 0;

       //passivo

       this.modelQualificacao.balancoFinanceiro.passivoCirculante02 = 0;
       this.modelQualificacao.balancoFinanceiro.exigivelLP02 = 0;
       this.modelQualificacao.balancoFinanceiro.resultExerciciosFut02 = 0;
       this.modelQualificacao.balancoFinanceiro.patrimonioLiquido02 = 0;

       //Receita

       this.modelQualificacao.balancoFinanceiro.capitalSocial02 = 0;
       this.modelQualificacao.balancoFinanceiro.receitaOpeLiquido02 = 0;
       this.modelQualificacao.balancoFinanceiro.receitaOpeBruto02 = 0;

       this.dtBalancoKey02++;
       this.valorKey02++;
       this.dataValidadeBalancoKey02++;
     }
   },
   validaReadonlyBalanco() {
     //verificar se nao é pra modificar o balanco
     var retorno = false;

     if (this.isAlteracao) {
       if (this.modelQualificacao.balancoFinanceiro.novoUpload) {
         return false;
       } else {
         return true;
       }
     }
     return retorno;
   },
   validaReadonlyBalanco02() {
     //verificar se nao é pra modificar o balanco
     var retorno = false;

     if (this.isAlteracao) {
       if (this.modelQualificacao.balancoFinanceiro.novoUpload02) {
         return false;
       } else {
         return true;
       }
     }
     return retorno;
   },

   

   validaDataVencida() {
     //verificar se a data é vencida
     return this.isAlteracao;
   },
   validaDataInvalida(v, validar) {
     //validar se data é invalida
      if(validar){
         if (!(this.model.tipoCertificado === 2 && (this.model.tipFornecedor === "J" || this.model.tipFornecedor === "F"))
             && this.model.flagEstrangeiro === 0) {
           return v.length === 10;
         } else {
           if (v) {
             return v.length === 10;
           } else {
             return true;
           }
         }
      } else {
        return true;
      }
   },
   baixarArquivo(arquivo) {
     //baixar o documento
     const numCgcFornecedor = this.$verificaPerfilCadastrador()
       ? this.model.numCgcFornecedor.replace(/[\W_]+/g, "")
       : null;
     fornecedorService.baixarArquivo(arquivo, numCgcFornecedor);
   },
   limparAnexo(tipo) {
     //limpar os documentos de qualificacao economica
     if (tipo === "concordata") {
       this.modelQualificacao.concordataFalencia.novoUpload = true;
       this.modelQualificacao.concordataFalencia.file = null;
       this.model.concordataFalencia.arquivoUpload = null;
       this.modelQualificacao.concordataFalencia.limparArquivoUpload = true;
     }

     if (tipo === "balanco") {
       this.modelQualificacao.balancoFinanceiro.novoUpload = true;
       this.modelQualificacao.balancoFinanceiro.file = null;
       this.model.balancoFinanceiro.arquivoUpload = null;
       this.modelQualificacao.balancoFinanceiro.limparArquivoUpload = true;
     }

     if (tipo === "balanco2") {
       this.modelQualificacao.balancoFinanceiro.novoUpload02 = true;
       this.modelQualificacao.balancoFinanceiro.file02 = null;
       this.model.balancoFinanceiro.arquivoUpload02 = null;
       this.model.balancoFinanceiro.dataValidadeBalanco02 = null;
       this.model.balancoFinanceiro.dtBalanco02 = null;
       this.modelQualificacao.balancoFinanceiro.limparArquivoUpload02 = true;
     }
   },
   openBox(item) {
     //abrir detalhe dos documentos
     const flag = this.isShow[item.chave + "" + item.valor];
     this.$set(this.isShow, item.chave + "" + item.valor, !flag);
   },
   calcAtivos() {
     //metodo para calular o total de ativo
     let _ativoNaoCirculante =
       Number(this.modelQualificacao.balancoFinanceiro.realizavelLP) +
       Number(this.modelQualificacao.balancoFinanceiro.imobilizado) +
       Number(this.modelQualificacao.balancoFinanceiro.investimento) +
       Number(this.modelQualificacao.balancoFinanceiro.intangivel);
     this.ativoNaoCirculante = _ativoNaoCirculante ? _ativoNaoCirculante : 0;

     let _ativoTotal =
       Number(this.ativoNaoCirculante) + Number(this.modelQualificacao.balancoFinanceiro.ativoCirculante);
     this.ativoTotal = _ativoTotal ? _ativoTotal : 0;
     this.totaisContas.ativoTotal = this.ativoTotal.toFixed(2);

     //metodo para calular o total de ativo BALANCO02limparAnexo
     let _ativoNaoCirculante02 =
       Number(this.modelQualificacao.balancoFinanceiro.realizavelLP02) +
       Number(this.modelQualificacao.balancoFinanceiro.imobilizado02) +
       Number(this.modelQualificacao.balancoFinanceiro.investimento02) +
       Number(this.modelQualificacao.balancoFinanceiro.intangivel02);
     this.ativoNaoCirculante02 = _ativoNaoCirculante02 ? _ativoNaoCirculante02 : 0;

     let _ativoTotal02 =
       Number(this.ativoNaoCirculante02) + Number(this.modelQualificacao.balancoFinanceiro.ativoCirculante02);
     this.ativoTotal02 = _ativoTotal02 ? _ativoTotal02 : 0;
     this.totaisContas.ativoTotal02 = this.ativoTotal02.toFixed(2);
   },
   calcPassivos() {
     //metodo para calcular o total de passivo
     let _passivoNaoCirculante =
       Number(this.modelQualificacao.balancoFinanceiro.exigivelLP) + Number(this.modelQualificacao.balancoFinanceiro.resultExerciciosFut);
     this.passivoNaoCirculante = _passivoNaoCirculante ? _passivoNaoCirculante : 0;

     let _passivoTotal =
       Number(this.passivoNaoCirculante) + Number(this.modelQualificacao.balancoFinanceiro.passivoCirculante) +
       Number(this.modelQualificacao.balancoFinanceiro.patrimonioLiquido);

     this.passivoTotal = _passivoTotal ? _passivoTotal : 0;
     this.totaisContas.passivoTotal = this.passivoTotal.toFixed(2);

      //metodo para calcular o total de passivo BALANÇO02

     let _passivoNaoCirculante02 =
       Number(this.modelQualificacao.balancoFinanceiro.exigivelLP02) + Number(this.modelQualificacao.balancoFinanceiro.resultExerciciosFut02);
     this.passivoNaoCirculante02 = _passivoNaoCirculante02 ? _passivoNaoCirculante02 : 0;

     let _passivoTotal02 =
       Number(this.passivoNaoCirculante02) + Number(this.modelQualificacao.balancoFinanceiro.passivoCirculante02) +
       Number(this.modelQualificacao.balancoFinanceiro.patrimonioLiquido02);

     this.passivoTotal02 = _passivoTotal02 ? _passivoTotal02 : 0;
     this.totaisContas.passivoTotal02 = this.passivoTotal02.toFixed(2);

   },
   calcSolvencia() {
     //calcular o valor de solvencia
     let cal1 =
       Number(this.modelQualificacao.balancoFinanceiro.ativoCirculante) + Number(this.ativoNaoCirculante);
     let cal2 =
       Number(this.modelQualificacao.balancoFinanceiro.passivoCirculante) + Number(this.modelQualificacao.balancoFinanceiro.exigivelLP);
     let resultado = cal1 && cal2 ? cal1 / cal2 : 0;
     this.solvenciaGeral = resultado ? resultado : 0;

      //calcular o valor de solvencia BALANÇO02
     let calc1 =
       Number(this.modelQualificacao.balancoFinanceiro.ativoCirculante02) + Number(this.ativoNaoCirculante02);
     let calc2 =
       Number(this.modelQualificacao.balancoFinanceiro.passivoCirculante02) + Number(this.modelQualificacao.balancoFinanceiro.exigivelLP02);
     let resultado2 = calc1 && calc2 ? calc1 / calc2 : 0;
     this.solvenciaGeral02 = resultado2 ? resultado2 : 0;

   },
   calcLiqCorrente() {
     //calcular o valor liquido corrente
     this.liquidezCorrente =
       Number(this.modelQualificacao.balancoFinanceiro.passivoCirculante)
         ? Number(this.modelQualificacao.balancoFinanceiro.ativoCirculante) / Number(this.modelQualificacao.balancoFinanceiro.passivoCirculante)
         : 0;
     //calcular o valor liquido corrente BALANÇO02
     this.liquidezCorrente02 =
       Number(this.modelQualificacao.balancoFinanceiro.passivoCirculante02)
         ? Number(this.modelQualificacao.balancoFinanceiro.ativoCirculante02) / Number(this.modelQualificacao.balancoFinanceiro.passivoCirculante02)
         : 0;    
   },
   calcLiqGeral() {
     //calcular o valor liquido geral
     let calc1 = Number(this.modelQualificacao.balancoFinanceiro.ativoCirculante) + Number(this.modelQualificacao.balancoFinanceiro.realizavelLP);
     let calc2 = Number(this.modelQualificacao.balancoFinanceiro.passivoCirculante) + Number(this.modelQualificacao.balancoFinanceiro.exigivelLP);

     this.liquidezGeral = calc1 && calc2 ? calc1 / calc2 : 0;
        
     //calcular o valor liquido geral BALANÇO02
     let cal1 = Number(this.modelQualificacao.balancoFinanceiro.ativoCirculante02) + Number(this.modelQualificacao.balancoFinanceiro.realizavelLP02);
     let cal2 = Number(this.modelQualificacao.balancoFinanceiro.passivoCirculante02) + Number(this.modelQualificacao.balancoFinanceiro.exigivelLP02);

     this.liquidezGeral02 = cal1 && cal2 ? cal1 / cal2 : 0;
   },
   calcProdutividade() {
     //calcular valor de produtividade
     let calc1 =
       Number(this.ativoTotal) - Number(this.modelQualificacao.balancoFinanceiro.investimento);

     this.produtividade = calc1 &&
       Number(this.modelQualificacao.balancoFinanceiro.receitaOpeLiquido) ? Number(this.modelQualificacao.balancoFinanceiro.receitaOpeLiquido) / calc1 : 0;
            
     //calcular valor de produtividade BALANÇO02
     let cal1 =
       Number(this.ativoTotal02) - Number(this.modelQualificacao.balancoFinanceiro.investimento02);
       
     this.produtividade02 = cal1 &&
       Number(this.modelQualificacao.balancoFinanceiro.receitaOpeLiquido02) ? Number(this.modelQualificacao.balancoFinanceiro.receitaOpeLiquido02) / cal1 : 0;
      
      
   },
   calcEndividamento() {
     //calcular valor de endividamento
     let calc1 =
       Number(this.modelQualificacao.balancoFinanceiro.passivoCirculante) +
       Number(this.modelQualificacao.balancoFinanceiro.exigivelLP);
     this.endividamento =
       calc1 && Number(this.ativoTotal) ? calc1 / Number(this.ativoTotal) : 0;
     
     //calcular valor de endividamento BALANÇO02
     let cal1 =
       Number(this.modelQualificacao.balancoFinanceiro.passivoCirculante02) +
       Number(this.modelQualificacao.balancoFinanceiro.exigivelLP02);
     this.endividamento02 =
       cal1 && Number(this.ativoTotal02) ? cal1 / Number(this.ativoTotal02) : 0;
   },
   calcCapitalizacao() {
     //calcular valor de capitalização
     this.capitalizacao = Number(this.ativoTotal)?
       (Number(this.modelQualificacao.balancoFinanceiro.patrimonioLiquido) / Number(this.ativoTotal)) * 100
       : 0;

      //calcular valor de capitalização BALANÇO02
     this.capitalizacao02 = Number(this.ativoTotal02)?
       (Number(this.modelQualificacao.balancoFinanceiro.patrimonioLiquido02) / Number(this.ativoTotal02)) * 100
       : 0; 
   },
   calcICP() {
     //calcular valor de ICP
     this.imobilizacaoCapitalProprio =
       Number(this.modelQualificacao.balancoFinanceiro.imobilizado) &&
       Number(this.modelQualificacao.balancoFinanceiro.patrimonioLiquido)?
         (Number(this.modelQualificacao.balancoFinanceiro.imobilizado) /
             Number(this.modelQualificacao.balancoFinanceiro.patrimonioLiquido)) * 100
         : 0;

      //calcular valor de ICP BALANÇO02
     this.imobilizacaoCapitalProprio02 =
       Number(this.modelQualificacao.balancoFinanceiro.imobilizado02) &&
       Number(this.modelQualificacao.balancoFinanceiro.patrimonioLiquido02)?
         (Number(this.modelQualificacao.balancoFinanceiro.imobilizado02) /
             Number(this.modelQualificacao.balancoFinanceiro.patrimonioLiquido02)) * 100
         : 0;   
   },
   getIndPont(codPontInd, valor) {
     //resgatar indice de pontacao
     let valores = this.pontuacaoIndices.find(
       pontuacao =>
         pontuacao.codPontInd == codPontInd &&
         valor >= pontuacao.limInf &&
         valor <= pontuacao.limSup
     );
     return valores ? valores.indPont : 0;
   },
   calcMediaFinanceira() {
     //calcular media financeira
     let ntProd = this.getIndPont(1, this.produtividade);
     let ntLG = this.getIndPont(2, this.liquidezGeral);
     let ntLC = this.getIndPont(3, this.liquidezCorrente);
     let ntCap = this.getIndPont(4, this.capitalizacao);
     let ntICP = this.getIndPont(5, this.imobilizacaoCapitalProprio);

     this.mediaFinanceira = (ntProd + ntLG + ntLC + ntCap + ntICP) / 5;

      //calcular media financeira BALANÇO02
      
     let ntProd2 = this.getIndPont(1, this.produtividade02);
     let ntLG2 = this.getIndPont(2, this.liquidezGeral02);
     let ntLC2 = this.getIndPont(3, this.liquidezCorrente02);
     let ntCap2 = this.getIndPont(4, this.capitalizacao02);
     let ntICP2 = this.getIndPont(5, this.imobilizacaoCapitalProprio02);

     this.mediaFinanceira02 = (ntProd2 + ntLG2 + ntLC2 + ntCap2 + ntICP2) / 5;

    
   },
   calcOldMediaFinanceira() {
     //calcular media financeira do modelo antigo
     let ntProd = this.getIndPont(1, this.OldModel.balancoFinanceiro.produtividade);
     let ntLG = this.getIndPont(2, this.OldModel.balancoFinanceiro.liquidezGeral);
     let ntLC = this.getIndPont(3, this.OldModel.balancoFinanceiro.liquidezCorrente);
     let ntCap = this.getIndPont(4, this.OldModel.balancoFinanceiro.capitalizacao);
     let ntICP = this.getIndPont(5, this.OldModel.balancoFinanceiro.imobilizacaoCapitalProprio);

    return (ntProd + ntLG + ntLC + ntCap + ntICP) / 5;

   },
   calcOldMediaFinanceira2() {

    //calcular media financeira do modelo antigo BALANÇO02
  
     let ntProd2 = this.getIndPont(1, this.OldModel.balancoFinanceiro.produtividade02);
     let ntLG2 = this.getIndPont(2, this.OldModel.balancoFinanceiro.liquidezGeral02);
     let ntLC2 = this.getIndPont(3, this.OldModel.balancoFinanceiro.liquidezCorrente02);
     let ntCap2 = this.getIndPont(4, this.OldModel.balancoFinanceiro.capitalizacao02);
     let ntICP2 = this.getIndPont(5, this.OldModel.balancoFinanceiro.imobilizacaoCapitalProprio02);

    return (ntProd2 + ntLG2 + ntLC2 + ntCap2 + ntICP2) / 5;
    
   },
   formatarNumero(valor, percent) {
     //formatar moeda e percentual
     return ((!percent ? "R$ " : "") +
       valor.toLocaleString("pt-BR", {
         minimumFractionDigits: 2,
         maximumFractionDigits: 2
       }) + (percent ? "%" : ""));
   },
   removeAprovacaoRejeicaoConcordata(concordata){
     concordata.arquivoUploadSituacao = null;
     concordata.dtRejeicao = null;
     concordata.idMotivoIndeferimentoArquivo = null;
   },
   removeAprovacaoRejeicaoBalanco(balanco){
     balanco.arquivoUploadSituacao = null;
     balanco.dtRejeicao = null;
     balanco.idMotivoIndeferimentoArquivo = null;
   },
   removeAprovacaoRejeicaoBalanco02(balanco){
     balanco.arquivoUploadSituacao02 = null;
     balanco.dtRejeicao02 = null;
     balanco.idMotivoIndeferimentoArquivo02 = null;
   }
 }
};
</script>
<style scoped> /*CSS especifico do componente*/
.divToolTip {
width: 30px !important;
float: left;
margin: 20px 0 0 -20px;
}

.titH1 {
text-transform: uppercase;
padding-top: 20px;
float: left;
}

.titBalanco {
width: 130px !important;
}

.v-list__tile {
 height: 60px;
}
.v-list__tile__sub-title {
 font-size: 11px;
}
.v-list__tile--active {
 font-family: gothambold;
}
.v-list__tile--active .v-list__tile__title {
 color: #333;
}
.theme--light.v-subheader {
 font-family: gothambold;
 color: #10618b;
}
.tipoItem {
 padding-top: 0;
}
.boxConcordata .v-toolbar__title {
 font-size: 13px !important;
 color: #10618b;
 width: 100%;
 text-align: right;
}
.boxIndices .v-toolbar__title > strong {
 display: block;
}
.boxIndices .v-toolbar__content {
 height: 52px !important;
}
.boxShadow .v-card__title .v-btn {
 margin-top: -10px;
}
.boxInfoDoc {
 width: 400px;
 font-size: 11px;
}
.positionBullet {
 margin: 0px 0 0 5px;
 cursor: pointer;
}
</style>
